// src/components/jnanadeepam/DailyMainsSecure.jsx
import React, { useState, useEffect, useMemo } from "react";
import {
  FileText,
  Clock,
  ChevronDown,
  ChevronUp,
  Calendar,
  Send,
  ThumbsUp,
  ArrowLeft,
  ArrowRight,
  Bold,
  Italic,
  Underline,
  Link as LinkIcon,
  Code,
  Quote,
  MessageSquare,
  Award,
  Printer,
  Check,
  Zap,
  Lock,
  Layers,
  Play,
  Search,
  Lightbulb,
  CheckCircle2,
  X,
  ChevronRight,
  Folder,
} from "lucide-react";

// Initial Archive Articles matching Screenshots 1, 2, 3
const defaultArchiveArticles = [
  // NOVEMBER 2026
  {
    date: "2026-11-03",
    day: "3",
    month: "NOV",
    year: "2026",
    monthName: "November 2026",
    title: "UPSC Mains Answer Writing Practice – Insights SECURE: 3 November 2026",
    formattedDate: "Tuesday, 3 November 2026",
    badge: "SECURE",
    isMini: false,
  },
  {
    date: "2026-11-02",
    day: "2",
    month: "NOV",
    year: "2026",
    monthName: "November 2026",
    title: "UPSC Mains Answer Writing Practice – Insights SECURE: 2 November 2026",
    formattedDate: "Monday, 2 November 2026",
    badge: "SECURE",
    isMini: false,
  },
  // OCTOBER 2026
  {
    date: "2026-10-31",
    day: "31",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights Mini SECURE: 31 October 2026",
    formattedDate: "Saturday, 31 October 2026",
    badge: "SECURE",
    isMini: true,
  },
  {
    date: "2026-10-30",
    day: "30",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights SECURE: 30 October 2026",
    formattedDate: "Friday, 30 October 2026",
    badge: "SECURE",
    isMini: false,
  },
  {
    date: "2026-10-29",
    day: "29",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights SECURE: 29 October 2026",
    formattedDate: "Thursday, 29 October 2026",
    badge: "SECURE",
    isMini: false,
  },
  {
    date: "2026-10-28",
    day: "28",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights SECURE: 28 October 2026",
    formattedDate: "Wednesday, 28 October 2026",
    badge: "SECURE",
    isMini: false,
  },
  {
    date: "2026-10-27",
    day: "27",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights SECURE: 27 October 2026",
    formattedDate: "Tuesday, 27 October 2026",
    badge: "SECURE",
    isMini: false,
  },
  {
    date: "2026-10-26",
    day: "26",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights SECURE: 26 October 2026",
    formattedDate: "Monday, 26 October 2026",
    badge: "SECURE",
    isMini: false,
  },
  {
    date: "2026-10-24",
    day: "24",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights Mini SECURE: 24 October 2026",
    formattedDate: "Saturday, 24 October 2026",
    badge: "SECURE",
    isMini: true,
  },
  {
    date: "2026-10-23",
    day: "23",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights SECURE: 23 October 2026",
    formattedDate: "Friday, 23 October 2026",
    badge: "SECURE",
    isMini: false,
  },
  {
    date: "2026-10-22",
    day: "22",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights SECURE: 22 October 2026",
    formattedDate: "Thursday, 22 October 2026",
    badge: "SECURE",
    isMini: false,
  },
  {
    date: "2026-10-21",
    day: "21",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights SECURE: 21 October 2026",
    formattedDate: "Wednesday, 21 October 2026",
    badge: "SECURE",
    isMini: false,
  },
  {
    date: "2026-10-20",
    day: "20",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights SECURE: 20 October 2026",
    formattedDate: "Tuesday, 20 October 2026",
    badge: "SECURE",
    isMini: false,
  },
  {
    date: "2026-10-19",
    day: "19",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights SECURE: 19 October 2026",
    formattedDate: "Monday, 19 October 2026",
    badge: "SECURE",
    isMini: false,
  },
  {
    date: "2026-10-17",
    day: "17",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights Mini SECURE: 17 October 2026",
    formattedDate: "Saturday, 17 October 2026",
    badge: "SECURE",
    isMini: true,
  },
  {
    date: "2026-10-16",
    day: "16",
    month: "OCT",
    year: "2026",
    monthName: "October 2026",
    title: "UPSC Mains Answer Writing Practice – Insights SECURE: 16 October 2026",
    formattedDate: "Friday, 16 October 2026",
    badge: "SECURE",
    isMini: false,
  },
];

// Curated questions for recent editions (3 Nov & 2 Nov 2026)
const extraCuratedQuestions = [
  // 3 November 2026 (Today)
  {
    id: "sec-20261103-q1",
    date: "2026-11-03",
    dateDisplay: "3 November 2026",
    edition: "Insights Daily SECURE",
    qNumber: "Q1",
    paper: "GS Paper 1",
    subject: "Physical Geography & Disasters",
    topic: "Important Geophysical phenomena such as earthquakes, Tsunami, Volcanic activity, GLOFs in the Himalayas.",
    marks: 15,
    words: 250,
    suggestedTime: "11 Minutes",
    difficulty: "Medium",
    directive: "Critically examine and Discuss",
    reference: "The Hindu / NDMA High-Altitude GLOF Vulnerability Report 2026",
    whyTheQuestion:
      "Rapid retreat of Himalayan glaciers has created over 2,000 glacial lakes at risk of outburst floods (GLOFs), threatening strategic downstream infrastructure in Sikkim and Uttarakhand.",
    keyDemand:
      "Examine the geomorphic and hydrological mechanisms causing GLOFs, evaluate ecological damage to river systems, and propose comprehensive community and engineering adaptation measures.",
    question:
      "“Climate-induced glacial retreat in the Third Pole has heightened the frequency and destructive potential of Glacial Lake Outburst Floods (GLOFs).” Critically examine their geomorphic impacts and discuss community-centric adaptation strategies. (15 Marks, 250 Words)",
    framework: {
      introduction:
        "Define GLOFs as catastrophic releases of water from moraine-dammed glacial lakes triggered by ice avalanches, seismicity, or piping. Situate the Hindu Kush Himalaya (HKH) as the vulnerable 'Water Tower of Asia'.",
      body: [
        "Geomorphic & Hydrological Impacts: Rapid debris-flow mobilization scouring river canyons; bed elevation changes through sudden sedimentation; destruction of riparian floodplains and fertile terraces.",
        "Infrastructure and Socio-Economic Vulnerability: Downstream hydropower stations washed away; isolation of border villages due to washed-out bridges; threat to water security.",
        "Adaptation & Risk Mitigation Framework: Automated early warning systems (lake monitoring sensors); mechanical lake siphoning and spillway channels; community-based disaster management (Aapda Mitra training); strictly regulating infrastructure construction in hazard zones.",
      ],
      conclusion:
        "Emphasize regional transboundary data-sharing (under ICIMOD) and embedding GLOF hazard micro-zonation into state developmental master plans to safeguard Himalayan ecologies.",
    },
    modelSynopsis:
      "Glacial Lake Outburst Floods (GLOFs) represent one of the most perilous manifestations of the accelerating cryospheric crisis across the Third Pole.\n\n1. Geomorphic & Ecological Transformations:\n- Hydro-Geomorphic Surges: Sudden release of millions of cubic meters of water scours steep valleys, stripping ancient soil covers and destabilizing hill slopes, precipitating subsequent landslides.\n- Fluvial Regime Changes: Massive sediment deposition raises riverbed levels downstream, elevating baseline flood risks for decades.\n\n2. Key Adaptation Strategies:\n- Structural Engineering: Controlled drainage via artificial spillways, siphoning pipelines, and moraine-dam stabilization works (as demonstrated successfully at Lake Tsho Rolpa).\n- Non-Structural Technologies: Multi-spectral satellite tracking (Cartosat, Sentinel) integrated with real-time acoustic sensors and automated sirens.\n- Community-Level Preparedness: Engaging local Panchayats in mock drills, establishing safe evacuation high-grounds, and enforcing resilient vernacular housing codes.\n\nTransforming disaster response from reactive compensation to proactive risk mitigation is essential.",
    evaluationCriteria: [
      "Distinguished geomorphic triggers (moraine breach, avalanches, seismicity)",
      "Clear differentiation between upstream geomorphic impact and downstream socio-economic damage",
      "Mentioned structural (siphoning, spillways) and non-structural (early warning, Aapda Mitra) measures",
      "Referenced national policies (NDMA Guidelines on GLOFs)",
    ],
  },
  {
    id: "sec-20261103-q2",
    date: "2026-11-03",
    dateDisplay: "3 November 2026",
    edition: "Insights Daily SECURE",
    qNumber: "Q2",
    paper: "GS Paper 2",
    subject: "Polity & Constitution",
    topic: "Separation of powers between various organs, dispute redressal mechanisms and institutions.",
    marks: 15,
    words: 250,
    suggestedTime: "11 Minutes",
    difficulty: "Analytical",
    directive: "Discuss in light of judicial pronouncements",
    reference: "Indian Express / Supreme Court Constitution Bench Rulings on Tribunals",
    whyTheQuestion:
      "Repeated executive enactments regarding search-cum-selection committees and service tenures for tribunal heads have triggered continuous scrutiny by the Supreme Court.",
    keyDemand:
      "Discuss how the doctrine of checks and balances preserves the independence of the judiciary and quasi-judicial tribunals without violating executive administrative prerogatives.",
    question:
      "“The doctrine of separation of powers in India is an organic system of checks and balances rather than rigid departmental compartmentalization.” Discuss in the light of judicial pronouncements on tribunal independence. (15 Marks, 250 Words)",
    framework: {
      introduction:
        "Differentiate between the rigid Montesquieu doctrine in the US Constitution and the flexible, coordinated model under the Indian Constitution (Ram Jawaya Kapur v. State of Punjab, 1955).",
      body: [
        "Checks and Balances as Basic Structure: Judicial review serves as the cornerstone to prevent executive or legislative overreach (Kesavananda Bharati, Indira Nehru Gandhi).",
        "The Battle over Tribunals: From L. Chandra Kumar (1997) to Madras Bar Association cases (2014, 2020, 2021). The Court held that quasi-judicial tribunals exercising judicial functions must possess institutional independence on par with High Courts.",
        "Tension Areas: Executive primacy in Search-cum-Selection Committees (SCSCs); short tenures of members undermining security of service; delayed infrastructure and appointments creating pendency.",
        "Preserving Constitutional Equilibrium: Establishing a National Tribunals Commission (NTC) as an independent administrative body to oversee appointments, finances, and functioning.",
      ],
      conclusion:
        "Conclude that checks and balances are not an impediment to governance, but the indispensable shield that guarantees constitutional morality and the Rule of Law.",
    },
    modelSynopsis:
      "Unlike the strict separation of powers in the American presidential model, India embraces an organic constitutional architecture founded on mutual accountability and institutional interdependence.\n\n1. Judicial Articulation of the Doctrine:\n- Ram Jawaya Kapur (1955): The executive exercises powers not strictly forbidden, yet remains subject to legislative accountability and judicial review.\n- Kesavananda Bharati (1973): Judicial review and the Rule of Law were declared inalienable facets of the Basic Structure.\n\n2. The Tribunals Conundrum:\n- In L. Chandra Kumar (1997), the Supreme Court ruled that tribunals are supplementary, not substitutional, to High Courts.\n- In the Madras Bar Association series of judgments, the apex court struck down statutory provisions that granted the executive dominance over judicial appointments, curtailed security of tenure, or compromised financial autonomy.\n\n3. The Way Forward:\nTo eliminate friction between the branches, India must operationalize a National Tribunals Commission (NTC) to supervise appointments, tenures, and budgetary requirements in an arm's-length, transparent manner.",
    evaluationCriteria: [
      "Quoted relevant landmark cases (Ram Jawaya, L. Chandra Kumar, Madras Bar Association)",
      "Explained organic checks & balances vs rigid separation",
      "Addressed issues in tribunal functioning (tenure, selection, NTC proposal)",
      "Balanced constitutional analysis",
    ],
  },
  {
    id: "sec-20261103-q3",
    date: "2026-11-03",
    dateDisplay: "3 November 2026",
    edition: "Insights Daily SECURE",
    qNumber: "Q3",
    paper: "GS Paper 3",
    subject: "Indian Economy & Technology",
    topic: "Industrial policy, indigenization of technology, developing new technology, semiconductor ecosystem.",
    marks: 15,
    words: 250,
    suggestedTime: "11 Minutes",
    difficulty: "Medium",
    directive: "Evaluate and Highlight bottlenecks",
    reference: "LiveMint / Ministry of Electronics & IT (MeitY) Semiconductor Updates 2026",
    whyTheQuestion:
      "India's semiconductor push has witnessed ground-breaking ceremonies for multiple fabrication and ATMP units under the ₹76,000 crore India Semiconductor Mission (ISM).",
    keyDemand:
      "Evaluate how a domestic semiconductor ecosystem drives geopolitical and economic sovereignty, while highlighting persistent bottlenecks in fab manufacturing.",
    question:
      "Evaluate the strategic significance of building a domestic semiconductor ecosystem for India’s economic sovereignty. What are the key bottlenecks under the India Semiconductor Mission (ISM)? (15 Marks, 250 Words)",
    framework: {
      introduction:
        "Introduce semiconductors as the 'new oil' of the 21st century—the foundational building blocks powering everything from consumer smartphones and EVs to defense satellites and quantum computing.",
      body: [
        "Strategic & Economic Significance: Insulating India from global supply chain weaponization (lessons from Taiwan Strait tensions); reducing massive electronics import bills; propelling high-value IP creation in fabless chip design.",
        "Government Policy Push: ₹76,000 Cr fiscal support under ISM covering up to 50% project costs; Design-Linked Incentive (DLI) for domestic startups; state-level complementary subsidies (Gujarat, Assam, UP).",
        "Key Structural Bottlenecks: Extreme capital intensity (a commercial fab costs $5-10 billion); infrastructure prerequisites (ultra-pure water in millions of liters daily, uninterrupted electricity without voltage flickers); dependency on critical upstream inputs (photolithography tools like ASML, specialty gases); talent deficit in fab manufacturing compared to fabless design.",
      ],
      conclusion:
        "Suggest focusing initially on compound semiconductors, mature trailing-edge nodes (28nm to 65nm for auto/industrial use), and deepening tie-ups under the Quad Critical Technology Network.",
    },
    modelSynopsis:
      "In an era where geopolitical supremacy is increasingly anchored in technological autonomy, semiconductors constitute the apex strategic commodity.\n\n1. Strategic Imperatives for India:\n- Supply Chain Resilience: Global chip production is concentrated in seismically and geopolitically sensitive Taiwan and East Asia. Domestic capacity mitigates severe vulnerability to trade disruptions.\n- Defense & Critical Infrastructure: Indigenous silicon eliminates backdoor espionage risks in telecom switches, radar guidance, and power grids.\n\n2. Core Bottlenecks in Semiconductor Fabrication:\n- Massive Capital Expenditure: Advanced semiconductor fabs require sustained reinvestment cycles exceeding tens of billions of dollars.\n- Resource & Infrastructure Demands: Fabs demand millions of gallons of ultrapure water (UPW) daily and zero-interruption, flicker-free power grids.\n- Upstream Monopolies: Extreme reliance on global monopolies (ASML for EUV scanners, Zeiss for optics, Japanese photoresists).\n\nIndia's pragmatic focus on ATMP/OSAT and mature nodes (28nm) builds a realistic stepping stone toward full-scale commercial fabrication.",
    evaluationCriteria: [
      "Highlighted geopolitical and economic dimensions of chip sovereignty",
      "Analyzed the India Semiconductor Mission (ISM) framework",
      "Identified concrete technical bottlenecks (ultrapure water, cleanrooms, talent, ASML tools)",
      "Offered viable policy roadmap (mature nodes, ATMP, Quad collaboration)",
    ],
  },
  {
    id: "sec-20261103-q4",
    date: "2026-11-03",
    dateDisplay: "3 November 2026",
    edition: "Insights Daily SECURE",
    qNumber: "Q4",
    paper: "GS Paper 4",
    subject: "Ethics in Public Administration",
    topic: "Public/Civil service values and Ethics in Public administration: Empathy, integrity, neutrality.",
    marks: 10,
    words: 150,
    suggestedTime: "7 Minutes",
    difficulty: "Analytical",
    directive: "Discuss with civil services examples",
    reference: "Ethics in Governance (2nd ARC) / Civil Service Reform Debates",
    whyTheQuestion:
      "Frequent bureaucratic controversies between technocratic rule-following and compassionate public grievance redressal underscore the essential balance between skill and moral empathy.",
    keyDemand:
      "Explain why technical competence without emotional empathy turns bureaucratic machinery into callous oppression, while empathy without competence results in well-intentioned administrative paralysis.",
    question:
      "“In public administration, empathy without competence is ineffective, but competence without empathy is dangerous.” Discuss with real-life examples from civil services. (10 Marks, 150 Words)",
    framework: {
      introduction:
        "Define competence (technical knowledge, legal mastery, procedural efficiency) and empathy (ability to inhabit citizen vulnerabilities and understand marginalized lived realities).",
      body: [
        "Empathy without Competence is Ineffective: A civil servant who genuinely feels for drought-hit farmers but lacks understanding of procurement rules, water budgeting, or fund execution fails to deliver substantive relief.",
        "Competence without Empathy is Dangerous: A brilliant technocrat who strictly denies rations or disability pensions due to biometric fingerprint mismatches acts legally but causes catastrophic human suffering (e.g., starvation deaths due to Aadhaar exclusion).",
        "Harmonious Synthesis in Public Service: Empathy provides the moral compass (the 'Why'), while competence provides the operational vehicle (the 'How').",
      ],
      conclusion:
        "Quote Sardar Vallabhbhai Patel or Second ARC: The ideal civil servant must possess the head of an administrator and the heart of a social reformer.",
    },
    modelSynopsis:
      "Public administration is fundamentally a moral enterprise directed toward human flourishing. Competence and empathy are its twin guiding virtues.\n\n1. Empathy without Competence is Ineffective:\nA public servant may feel genuine compassion for disadvantaged citizens, but without mastery over budgeting, administrative law, and project management, that goodwill cannot translate into concrete welfare delivery. Good intentions cannot substitute for executive capacity.\n\n2. Competence without Empathy is Dangerous:\nA technocrat armed with efficiency but devoid of human compassion turns administrative machinery into a rigid, unyielding cage. For instance, strictly canceling welfare entitlements of elderly widows because biometric machines fail to read weathered fingerprints is procedurally defensible but morally abhorrent.\n\n3. The Ethical Ideal:\nTrue bureaucratic excellence lies in 'compassionate competence'—using creative administrative discretion within legal bounds to serve the last citizen in the queue (Gandhian Talisman).",
    evaluationCriteria: [
      "Clearly explained both halves of the prompt",
      "Provided practical civil service examples (ration delivery, disaster relief, disability aid)",
      "Synthesized the two virtues into compassionate competence",
      "Mentioned relevant ethical frameworks (Gandhian Talisman, 2nd ARC)",
    ],
  },

  // 2 November 2026
  {
    id: "sec-20261102-q1",
    date: "2026-11-02",
    dateDisplay: "2 November 2026",
    edition: "Insights Daily SECURE",
    qNumber: "Q1",
    paper: "GS Paper 1",
    subject: "Urban Geography & Environment",
    topic: "Urbanization, their problems and their remedies; changes in water bodies and climate extremes.",
    marks: 15,
    words: 250,
    suggestedTime: "11 Minutes",
    difficulty: "Medium",
    directive: "Analyze factors and Highlight concepts",
    reference: "Down to Earth / CEEW Urban Flooding Analysis",
    whyTheQuestion:
      "Severe urban flooding in Chennai, Bengaluru, and Delhi during extreme rainfall spells has highlighted the inadequacy of conventional grey storm-water drainage.",
    keyDemand:
      "Analyze the causes of chronic urban deluge and explain how nature-based solutions like 'Sponge Cities' can restore urban hydrological resilience.",
    question:
      "Analyze the factors responsible for the recurrent phenomenon of urban flooding in Indian megacities. How can the 'Sponge City' paradigm foster urban resilience? (15 Marks, 250 Words)",
    framework: {
      introduction:
        "Define urban flooding not as an act of nature, but as a man-made hydrological disaster caused by rampant concretization, encroachment of natural wetlands, and inadequate storm drainage.",
      body: [
        "Drivers of Deluge: Concretization destroying infiltration capacity (impervious surface ratio > 80%); encroachment of natural lake chains and nalas (e.g., Bengaluru raja kaluves); outdated drainage networks designed for low-intensity rainfall; solid waste choking culverts.",
        "The Sponge City Concept: An urban planning paradigm where cities mimic natural watersheds—absorbing, storing, infiltrating, and purifying rainwater for reuse.",
        "Core Interventions: Permeable pavements and bio-swales; urban retention wetlands and biosponge parks; rooftop rainwater harvesting mandates; preserving lake cascades with designated flood buffers.",
      ],
      conclusion:
        "Urban planning must shift from 'fighting runoff with concrete' to 'living with water' through blue-green infrastructure (Master Plans with dedicated Water Action Plans).",
    },
    modelSynopsis:
      "Urban flooding in contemporary India is no longer an occasional anomaly; it is an annual structural crisis driven by unplanned real estate expansion over natural watersheds.\n\n1. Key Drivers:\n- Loss of Infiltration: Massive urban sprawl has coated cities in concrete, skyrocketing surface runoff coefficients from 0.2 to over 0.8.\n- Destruction of Natural Drainage: Lake cascades and interconnected storm channels have been fragmented by road and building construction.\n\n2. The Sponge City Solution:\nPioneered in cities like Wuhan and Singapore, sponge infrastructure incorporates:\n- Permeable Surface Infrastructure: Porous asphalt for roads and pedestrian paths.\n- Vegetated Swales & Rain Gardens: Capturing and filtering first-flush runoff.\n- Decentralized Retention Basins: Storing excess rainwater for aquifer recharge.\n\nAdopting blue-green master planning is critical for climate-proofing Indian cities.",
    evaluationCriteria: [
      "Distinguished natural river floods from urban flooding",
      "Explained Sponge City components (permeable pavements, bioswales, retention parks)",
      "Gave Indian city examples (Chennai, Bengaluru, Delhi)",
      "Balanced technical and urban governance solutions",
    ],
  },
  {
    id: "sec-20261102-q2",
    date: "2026-11-02",
    dateDisplay: "2 November 2026",
    edition: "Insights Daily SECURE",
    qNumber: "Q2",
    paper: "GS Paper 2",
    subject: "Governance & Rights",
    topic: "Welfare schemes for vulnerable sections, mechanisms, laws, institutions and Bodies constituted for the protection of these vulnerable sections.",
    marks: 15,
    words: 250,
    suggestedTime: "11 Minutes",
    difficulty: "Medium",
    directive: "Critically evaluate",
    reference: "The Hindu / Supreme Court Data Privacy & DPDP Act Implementation",
    whyTheQuestion:
      "The rollout of rules under the Digital Personal Data Protection (DPDP) Act has reignited debates on citizen surveillance, state exemptions, and privacy rights.",
    keyDemand:
      "Critically evaluate whether the DPDP framework strikes a fair balance between state administrative necessity and the fundamental right to privacy declared in Puttaswamy.",
    question:
      "“Data privacy legislation must neither become a license for unfettered state surveillance nor a barrier to efficient welfare delivery.” Critically evaluate this statement in light of India’s digital data protection framework. (15 Marks, 250 Words)",
    framework: {
      introduction:
        "Reference Justice K.S. Puttaswamy (2017) judgment establishing privacy as an intrinsic fundamental right under Article 21, subject only to legality, necessity, and proportionality.",
      body: [
        "Welfare Delivery & Digital Governance: Digital Public Infrastructure (DPI/India Stack) enables Direct Benefit Transfers (DBT), eliminating leakages and ghost beneficiaries.",
        "Critique of State Exemptions: Broad exemptions granted to government agencies under national security grounds without robust judicial oversight; weakening of the Right to Information (RTI) Act exemptions.",
        "Independence of the Regulatory Body: Concerns regarding the appointment and autonomy of the Data Protection Board (DPB) by the central executive.",
      ],
      conclusion:
        "Recommend independent parliamentary oversight for state surveillance exemptions and algorithmic accountability to prevent exclusionary welfare denial.",
    },
    modelSynopsis:
      "India's journey toward digital governance presents an ongoing constitutional challenge: harmonizing state efficiency with citizen autonomy.\n\n1. The Imperative of Efficient Welfare:\nDigital IDs and direct transfers have revolutionized social security, plugging massive leakages across PDS and rural employment schemes.\n\n2. Privacy Vulnerabilities in Current Law:\n- Expansive State Carve-Outs: Blanket exemptions under national security without mandatory judicial warrants violate the proportionality test laid down in Puttaswamy.\n- RTI Dilution: Amendments prohibiting disclosure of all personal information restrict public transparency on government contracts and welfare rolls.\n\n3. Restoring Equilibrium:\nA truly robust privacy regime requires an independent Data Protection Authority insulated from executive control and clear safeguards against surveillance overreach.",
    evaluationCriteria: [
      "Cited Puttaswamy proportionality three-fold test",
      "Evaluated both welfare benefits (DBT, DPI) and privacy hazards (surveillance, RTI dilution)",
      "Commented on Data Protection Board independence",
      "Offered constructive institutional reforms",
    ],
  },
  {
    id: "sec-20261102-q3",
    date: "2026-11-02",
    dateDisplay: "2 November 2026",
    edition: "Insights Daily SECURE",
    qNumber: "Q3",
    paper: "GS Paper 3",
    subject: "Energy & Infrastructure",
    topic: "Infrastructure: Energy, Ports, Roads, Clean Energy Transition, Nuclear Energy.",
    marks: 15,
    words: 250,
    suggestedTime: "11 Minutes",
    difficulty: "Medium",
    directive: "Assess viability",
    reference: "NITI Aayog Report on Small Modular Reactors (SMRs) / Department of Atomic Energy",
    whyTheQuestion:
      "NITI Aayog and the Department of Atomic Energy have invited private sector participation to commercialize Small Modular Reactors (SMRs) to decarbonize heavy industrial sectors.",
    keyDemand:
      "Assess how SMRs can complement renewable energy intermittency to fulfill India's Net-Zero 2070 commitments and analyze legislative/commercial bottlenecks.",
    question:
      "Assess the potential and viability of Small Modular Reactors (SMRs) in accelerating India’s clean energy transition and achieving Net-Zero emissions by 2070. (15 Marks, 250 Words)",
    framework: {
      introduction:
        "Define Small Modular Reactors (SMRs) as advanced nuclear fission reactors producing up to 300 MW(e) per unit, manufactured modularly in factories and assembled on site.",
      body: [
        "Strategic Potential: Provides firm, base-load low-carbon power to balance solar/wind intermittency; ideal for replacing retiring thermal coal boilers without requiring new transmission corridors; can supply high-temperature process heat for steel, cement, and hydrogen manufacturing.",
        "Safety and Deployment Advantages: Passive safety systems that do not require external power or human intervention during emergencies; lower capital threshold compared to massive GW-scale gigawatt reactors.",
        "Viability Bottlenecks: Civil Liability for Nuclear Damage Act (CLNDA) 2010 supplier liability concerns hindering foreign tech transfer; high initial unit costs pending economies of serial factory manufacturing; nuclear fuel supply agreements and radioactive waste disposal logistics.",
      ],
      conclusion:
        "Encourage amending the Atomic Energy Act to allow controlled public-private joint ventures and developing indigenous 220 MWe PHWR-based SMR designs.",
    },
    modelSynopsis:
      "As India expands its renewable energy footprint, grid stability necessitates firm, dispatchable clean base-load power. Small Modular Reactors (SMRs) offer a transformative technological bridge.\n\n1. Strategic Advantages of SMRs:\n- Brownfield Repurposing: SMRs can directly replace retiring coal plant boilers, utilizing existing grid interconnects, cooling water lines, and land parcels.\n- Industrial Decarbonization: Beyond electricity, high-temperature SMRs can generate industrial heat for hard-to-abate sectors like fertilizers, chemicals, and green steel.\n- Enhanced Passive Safety: Gravity-driven and natural circulation cooling mechanisms virtually eliminate catastrophic meltdown risks.\n\n2. Key Challenges:\n- Commercial Cost Realization: Factory economies of scale will only materialize after dozens of identical units are commissioned.\n- Legal Bottlenecks: Supplier liability clauses under CLNDA 2010 continue to deter private and international consortiums.\n\nDeveloping indigenous pressurized heavy water reactor (PHWR) derivatives offers India a competitive edge in global SMR manufacturing.",
    evaluationCriteria: [
      "Defined SMR specifications (<300 MWe, modular construction)",
      "Highlighted brownfield coal-plant retrofitting and industrial process heat applications",
      "Addressed nuclear liability (CLNDA) and regulatory hurdles",
      "Outlined connection to Net Zero 2070 goal",
    ],
  },
  {
    id: "sec-20261102-q4",
    date: "2026-11-02",
    dateDisplay: "2 November 2026",
    edition: "Insights Daily SECURE",
    qNumber: "Q4",
    paper: "GS Paper 4",
    subject: "Applied Technology Ethics",
    topic: "Ethics in private and public relationships, emerging technologies, surveillance vs dignity.",
    marks: 10,
    words: 150,
    suggestedTime: "7 Minutes",
    difficulty: "Medium",
    directive: "Discuss ethical dimensions",
    reference: "UNESCO Recommendation on the Ethics of Artificial Intelligence",
    whyTheQuestion:
      "The deployment of automated facial recognition and predictive algorithmic policing in metropolitan police departments has sparked civil liberty and bias debates.",
    keyDemand:
      "Discuss the ethical hazards of algorithmic bias, automated guilt, erosion of presumption of innocence, and the panoptic state.",
    question:
      "Discuss the ethical dimensions and human rights implications of deploying artificial intelligence in citizen surveillance and predictive policing. (10 Marks, 150 Words)",
    framework: {
      introduction:
        "Acknowledge the allure of AI in crime prevention and traffic monitoring, but warn against algorithmic determinism eroding constitutional liberties and human dignity.",
      body: [
        "Algorithmic Bias and Discrimination: Training datasets often reflect historical over-policing of marginalized communities, causing algorithms to reinforce systemic prejudices.",
        "Erosion of Constitutional Presumption: Predictive policing risks shifting justice from 'innocent until proven guilty' to pre-emptive suspicion, criminalizing marginalized individuals before an act is committed.",
        "The Chilling Effect on Dissent: Ubiquitous facial recognition in public squares suppresses democratic protest, assembly, and bodily privacy (Panopticon effect).",
      ],
      conclusion:
        "Demand meaningful human-in-the-loop safeguards, algorithmic transparency (black-box audits), and strict adherence to UNESCO's Ethics of AI guidelines.",
    },
    modelSynopsis:
      "The integration of Artificial Intelligence into law enforcement promises unprecedented surveillance efficiency, but creates grave ethical dilemmas.\n\n1. Inherent Algorithmic Bias:\nAI models trained on historical arrest data perpetuate and amplify pre-existing human prejudices. Minorities and impoverished demographics are disproportionately flagged for surveillance.\n\n2. Subversion of Due Process:\nPredictive policing algorithms operate on opaque probabilistic reasoning, undermining the fundamental jurisprudence of 'presumption of innocence' and individual moral agency.\n\n3. The Panoptic Society:\nContinuous biometric tracking strips citizens of anonymity in public spaces, creating a chilling effect on legitimate constitutional freedoms of speech, assembly, and political dissent.\n\nAI must remain an assistive operational tool subject to independent human review and strict judicial warrants.",
    evaluationCriteria: [
      "Identified algorithmic bias and training dataset skew",
      "Discussed impact on fundamental rights (Articles 19 and 21)",
      "Referenced ethical concepts (presumption of innocence, Bentham's Panopticon, human agency)",
      "Proposed guardrails (transparency audits, human-in-the-loop)",
    ],
  },
];

export default function DailyMainsSecure({
  questions = [],
  backendMains = [],
  initialDate = null,
}) {
  // Combine static and extra curated questions with any backend dynamic initiatives from MongoDB
  const allQuestions = useMemo(() => {
    const list = [...extraCuratedQuestions, ...questions];

    // If backend published initiatives exist, transform them into questions format
    if (backendMains && backendMains.length > 0) {
      backendMains.forEach((bm) => {
        const bDate = bm.deadline
          ? new Date(bm.deadline).toISOString().split("T")[0]
          : bm.publishedAt
          ? new Date(bm.publishedAt).toISOString().split("T")[0]
          : "2026-11-03";

        (bm.questions || []).forEach((q, idx) => {
          list.unshift({
            id: q._id || `bm-${bm._id}-${idx}`,
            date: bDate,
            dateDisplay: new Date(bDate).toLocaleDateString("en-IN", {
              day: "numeric",
              month: "long",
              year: "numeric",
            }),
            edition: bm.title || "Daily Mains Practice",
            qNumber: `Q${idx + 1}`,
            paper: bm.gsPaper || "GS Paper 2",
            subject: bm.subject || "General Studies",
            topic: bm.topic || bm.description || "UPSC Mains Practice",
            marks: q.maxMarks || 15,
            words: q.wordLimit || 250,
            suggestedTime: "11 Minutes",
            difficulty: "Medium",
            directive: "Discuss",
            reference: "Selva's IAS Faculty Editorial Team",
            whyTheQuestion: bm.description || "Daily Mains Initiative",
            keyDemand: q.questionText,
            question: q.questionText,
            framework: {
              introduction: "Introduce with key constitutional / conceptual definitions.",
              body: [
                "Examine core dimensions of the question using sub-headings.",
                "Provide contemporary examples, case laws, and committee recommendations.",
              ],
              conclusion: "Conclude with forward-looking constructive solutions.",
            },
            modelSynopsis:
              "Structure your answer with clear Introduction, Multi-dimensional body arguments (PESTLE), and a progressive Way Forward.",
            evaluationCriteria: [
              "Direct response to directive",
              "Multi-dimensional analysis",
              "Relevant examples cited",
            ],
          });
        });
      });
    }

    return list;
  }, [questions, backendMains]);

  // Build the complete archive articles list
  const archiveArticles = useMemo(() => {
    const items = [...defaultArchiveArticles];

    // If backend initiatives have dates not in default list, inject them at top
    if (backendMains && backendMains.length > 0) {
      backendMains.forEach((bm) => {
        const bDate = bm.deadline
          ? new Date(bm.deadline).toISOString().split("T")[0]
          : "2026-11-03";

        const existing = items.find((a) => a.date === bDate);
        if (!existing) {
          const dObj = new Date(bDate);
          items.unshift({
            date: bDate,
            day: String(dObj.getDate()),
            month: dObj.toLocaleString("en-US", { month: "short" }).toUpperCase(),
            year: String(dObj.getFullYear()),
            monthName: dObj.toLocaleString("en-US", { month: "long", year: "numeric" }),
            title: `UPSC Mains Answer Writing Practice – Selva's SECURE: ${bm.title}`,
            formattedDate: dObj.toLocaleDateString("en-IN", {
              weekday: "long",
              day: "numeric",
              month: "long",
              year: "numeric",
            }),
            badge: "SECURE",
            isMini: false,
          });
        }
      });
    }

    return items;
  }, [backendMains]);

  // View state: 'archive' (listing) | 'questions' (date's question list) | 'detail' (single question view)
  const [viewMode, setViewMode] = useState(initialDate ? "questions" : "archive");
  const [selectedDate, setSelectedDate] = useState(initialDate || "2026-11-03");
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);

  // Filter state on Archive view
  const [yearFilter, setYearFilter] = useState("2026");
  const [monthFilter, setMonthFilter] = useState("All");
  const [folderFilter, setFolderFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  const mainsSubjectFolders = [
    "All",
    "Indian Polity",
    "Governance",
    "International Relations",
    "History",
    "Geography",
    "Indian Economy",
    "Environment",
    "Science & Technology",
    "Internal Security",
    "Ethics & Integrity",
    "Essay Writing",
  ];

  // Quick Action Modal state
  const [activeModal, setActiveModal] = useState(null);

  // Expanded synopsis toggle in detail view
  const [showSynopsis, setShowSynopsis] = useState(false);

  // Reaction counters per question
  const [reactions, setReactions] = useState({});

  // Comment input state for the active question
  const [commentText, setCommentText] = useState("");
  const [candidateName, setCandidateName] = useState("");
  const [candidateEmail, setCandidateEmail] = useState("");
  const [isOver18, setIsOver18] = useState(true);
  const [formErrors, setFormErrors] = useState({});
  const [uploadedAttachment, setUploadedAttachment] = useState(null);

  // Per-question discussion comments stream
  const [discussions, setDiscussions] = useState({
    "sec-20261103-q1": [
      {
        id: "c_glof_1",
        author: "Abhinav Mohan (Rank 42, 2024)",
        initial: "A",
        time: "45 minutes ago",
        text: "Crucial point here is mentioning the Moraine breach mechanism. Moraines are unconsolidated scree and ice-cored debris. When hydrostatic pressure exceeds structural shear strength, rapid internal piping triggers sudden dam failure.",
        likes: 18,
        replies: 2,
        userLiked: true,
      },
      {
        id: "c_glof_2",
        author: "Mentor Dr. Selva (Director)",
        initial: "S",
        isMentor: true,
        time: "2 hours ago",
        text: "Excellent question topic! Candidates must draw a simple 2-part cross-section showing: (1) Glacial Lake with Moraine Dam, and (2) Downstream debris-flow torrent. Reference Sikkim South Lhonak lake incident (2023) and Chungthang dam wash-away as concrete proof.",
        likes: 34,
        replies: 4,
        userLiked: false,
      },
    ],
    "sec-20261031-q1": [
      {
        id: "c1",
        author: "Karthik Raja (Aspirant 2026)",
        initial: "K",
        time: "1 hour ago",
        text: "The Bjerknes positive feedback loop is central here. Weakening trade winds diminish upwelling along the Peruvian coast, allowing warm water to slosh eastward as downwelling Kelvin waves. This flattens the zonal sea surface temperature gradient, which in turn further weakens the Walker circulation and relaxes the trade winds.",
        likes: 12,
        replies: 3,
        userLiked: false,
      },
      {
        id: "c2",
        author: "Mentor Dr. Selva (Director)",
        initial: "S",
        isMentor: true,
        time: "3 hours ago",
        text: "Important Directive Focus: Notice the word 'Explain this feedback mechanism'. Candidates must clearly address both causal directions: (1) Wind relaxation -> Ocean warming, and (2) Ocean warming -> Tropospheric pressure gradient collapse -> Further wind relaxation. Draw the 2-box schematic diagram.",
        likes: 28,
        replies: 5,
        userLiked: false,
      },
    ],
  });

  // Exam Stopwatch state
  const [timerRunning, setTimerRunning] = useState(false);
  const [timerSeconds, setTimerSeconds] = useState(0);

  // Stopwatch timer effect
  useEffect(() => {
    let interval = null;
    if (timerRunning) {
      interval = setInterval(() => {
        setTimerSeconds((prev) => prev + 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timerRunning]);

  // Questions for current selected date
  const dateQuestions = useMemo(() => {
    const list = allQuestions.filter((q) => q.date === selectedDate);
    if (list.length > 0) return list;

    // Fallback: If date not found in static list, provide high-quality fallback questions
    const fallbackDateStr = selectedDate;
    return [
      {
        id: `fb-${fallbackDateStr}-q1`,
        date: fallbackDateStr,
        dateDisplay: fallbackDateStr,
        edition: "Insights Daily SECURE",
        qNumber: "Q1",
        paper: "GS Paper 1",
        subject: "Geography & Ecology",
        topic: "Geophysical phenomena, climate variability, and environmental resources.",
        marks: 15,
        words: 250,
        suggestedTime: "11 Minutes",
        difficulty: "Medium",
        directive: "Examine with examples",
        reference: "The Hindu / Down to Earth",
        whyTheQuestion: "Critical topic linking contemporary climate events to UPSC syllabus.",
        keyDemand: "Analyze causes, environmental impacts, and long-term mitigation measures.",
        question: `Examine the impact of climate extremes on regional agricultural cycles and food security in India. Discuss sustainable agro-ecological adaptations. (15 Marks, 250 Words)`,
        framework: {
          introduction: "Highlight changing precipitation rhythms and monsoonal shifts.",
          body: [
            "Impact on Kharif and Rabi cycles: heatwaves during grain-filling; unseasonal rainfall during harvest.",
            "Agro-ecological remedies: Zero Budget Natural Farming, climate-resilient seed varieties (CRIDA), micro-irrigation.",
          ],
          conclusion: "Conclude with mission-mode climate adaptation in agrarian livelihoods.",
        },
        modelSynopsis:
          "Integrate agro-climatic zones, ICAR climate-resilient varieties, and PM Krishi Sinchayee Yojana.",
        evaluationCriteria: ["Direct response to directive", "Agro-climatic examples"],
      },
      {
        id: `fb-${fallbackDateStr}-q2`,
        date: fallbackDateStr,
        dateDisplay: fallbackDateStr,
        edition: "Insights Daily SECURE",
        qNumber: "Q2",
        paper: "GS Paper 2",
        subject: "Polity & Governance",
        topic: "Statutory, regulatory and various quasi-judicial bodies.",
        marks: 15,
        words: 250,
        suggestedTime: "11 Minutes",
        difficulty: "Medium",
        directive: "Critically evaluate",
        reference: "Indian Express / Law Commission Reports",
        whyTheQuestion: "Regulatory autonomy and constitutional checks and balances.",
        keyDemand: "Evaluate functional independence and propose institutional reforms.",
        question: `“The effectiveness of independent regulatory authorities in India depends on institutional autonomy and financial insulation.” Critically evaluate with examples. (15 Marks, 250 Words)`,
        framework: {
          introduction: "Define regulatory state in post-1991 liberalization context.",
          body: [
            "Institutional strengths: Technical domain expertise; agile rulemaking.",
            "Vulnerabilities: Post-retirement appointments; budget dependency on parent ministries.",
          ],
          conclusion: "Advocate for dedicated parliamentary scrutiny committees for regulators.",
        },
        modelSynopsis:
          "Contrast TRAI, CCI, and SEBI in terms of dispute settlement and executive interface.",
        evaluationCriteria: ["Case examples", "Statutory references"],
      },
      {
        id: `fb-${fallbackDateStr}-q3`,
        date: fallbackDateStr,
        dateDisplay: fallbackDateStr,
        edition: "Insights Daily SECURE",
        qNumber: "Q3",
        paper: "GS Paper 3",
        subject: "Economy & Infrastructure",
        topic: "Infrastructure: Energy, Ports, Roads, Clean Energy Transition.",
        marks: 15,
        words: 250,
        suggestedTime: "11 Minutes",
        difficulty: "Medium",
        directive: "Discuss",
        reference: "Economic Survey / NITI Aayog Infrastructure Pipelines",
        whyTheQuestion: "Logistics efficiency and manufacturing competitiveness.",
        keyDemand: "Evaluate PM Gati Shakti and National Logistics Policy.",
        question: `Discuss the role of multi-modal logistics networks in enhancing the global competitiveness of India’s manufacturing sector. (15 Marks, 250 Words)`,
        framework: {
          introduction: "State India's logistics cost as percentage of GDP (~13-14% vs 8% global benchmark).",
          body: [
            "Modal shift: Moving freight from road (65%) to rail and inland waterways.",
            "PM Gati Shakti Master Plan: Integrated GIS planning across 16 ministries.",
          ],
          conclusion: "Emphasize green logistics corridors and Dedicated Freight Corridors (DFCs).",
        },
        modelSynopsis: "Focus on multi-modal logistics parks (MMLPs) and ULIP digital portal integration.",
        evaluationCriteria: ["Data points", "Logistics policy pillars"],
      },
      {
        id: `fb-${fallbackDateStr}-q4`,
        date: fallbackDateStr,
        dateDisplay: fallbackDateStr,
        edition: "Insights Daily SECURE",
        qNumber: "Q4",
        paper: "GS Paper 4",
        subject: "Ethics in Administration",
        topic: "Probity in Governance, Ethical dilemmas, Whistleblowing.",
        marks: 10,
        words: 150,
        suggestedTime: "7 Minutes",
        difficulty: "Analytical",
        directive: "Comment with examples",
        reference: "Second Administrative Reforms Commission (2nd ARC)",
        whyTheQuestion: "Moral courage and duty of loyalty in public service.",
        keyDemand: "Examine conflict between organizational loyalty and public interest.",
        question: `“When organizational loyalty conflicts with the public interest, an ethical civil servant must let conscience prevail.” Comment. (10 Marks, 150 Words)`,
        framework: {
          introduction: "Define organizational loyalty vs constitutional fidelity.",
          body: [
            "The dilemma: Superior's order vs public probity.",
            "Kantian deontological duty to truth vs pragmatic obedience.",
          ],
          conclusion: "Constitutional morality is the ultimate master of a civil servant.",
        },
        modelSynopsis: "Reference Whistleblowers Protection Act and Satyendra Dubey case.",
        evaluationCriteria: ["Ethical clarity", "Civil services context"],
      },
    ];
  }, [allQuestions, selectedDate]);

  // Group questions by General Studies Paper
  const gsPapers = [
    { title: "General Studies – 1", code: "GS Paper 1" },
    { title: "General Studies – 2", code: "GS Paper 2" },
    { title: "General Studies – 3", code: "GS Paper 3" },
    { title: "General Studies – 4", code: "GS Paper 4" },
  ];

  // Active question object (if in detail view)
  const activeQuestion = selectedQuestionId
    ? allQuestions.find((q) => q.id === selectedQuestionId) || dateQuestions[0]
    : null;

  // Find index and prev/next questions
  const currentIndex = activeQuestion
    ? dateQuestions.findIndex((q) => q.id === activeQuestion.id)
    : -1;
  const prevQuestion =
    currentIndex > 0 ? dateQuestions[currentIndex - 1] : null;
  const nextQuestion =
    currentIndex >= 0 && currentIndex < dateQuestions.length - 1
      ? dateQuestions[currentIndex + 1]
      : null;

  // Filtering on Archive View
  const filteredArchiveArticles = useMemo(() => {
    return archiveArticles.filter((art) => {
      // Year filter
      if (yearFilter !== "All" && art.year !== yearFilter) return false;

      // Month filter
      if (monthFilter !== "All") {
        if (!art.monthName.toLowerCase().includes(monthFilter.toLowerCase())) {
          return false;
        }
      }

      // Folder filter
      if (folderFilter !== "All") {
        const matchesArticleFolder =
          (art.folder && art.folder.toLowerCase() === folderFilter.toLowerCase()) ||
          (art.subject && art.subject.toLowerCase() === folderFilter.toLowerCase()) ||
          allQuestions.some(
            (q) =>
              q.date === art.date &&
              ((q.folder && q.folder.toLowerCase().includes(folderFilter.toLowerCase())) ||
               (q.subject && q.subject.toLowerCase().includes(folderFilter.toLowerCase())))
          );
        if (!matchesArticleFolder) return false;
      }

      // Search query
      if (searchQuery.trim()) {
        const q = searchQuery.toLowerCase();
        const matchesTitle = art.title.toLowerCase().includes(q);
        const matchesDate = art.formattedDate.toLowerCase().includes(q);
        const matchesDateRaw = art.date.toLowerCase().includes(q);
        if (!matchesTitle && !matchesDate && !matchesDateRaw) return false;
      }

      return true;
    });
  }, [archiveArticles, yearFilter, monthFilter, folderFilter, searchQuery, allQuestions]);

  // Group filtered archive articles by Month (e.g. "NOVEMBER 2026", "OCTOBER 2026")
  const groupedArticles = useMemo(() => {
    const groups = {};
    filteredArchiveArticles.forEach((item) => {
      const mName = item.monthName.toUpperCase();
      if (!groups[mName]) groups[mName] = [];
      groups[mName].push(item);
    });
    return groups;
  }, [filteredArchiveArticles]);

  // Handle selecting a date to open its question page
  const handleOpenDateArticle = (dateStr) => {
    setSelectedDate(dateStr);
    setSelectedQuestionId(null);
    setShowSynopsis(false);
    setViewMode("questions");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Open question detail view
  const openQuestionDetail = (qId) => {
    setSelectedQuestionId(qId);
    setShowSynopsis(false);
    setTimerRunning(false);
    setTimerSeconds(0);
    setCommentText("");
    setUploadedAttachment(null);
    setFormErrors({});
    setViewMode("detail");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Back to question list for current date
  const backToDateQuestions = () => {
    setSelectedQuestionId(null);
    setShowSynopsis(false);
    setTimerRunning(false);
    setViewMode("questions");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Back to archive listing
  const backToArchive = () => {
    setSelectedQuestionId(null);
    setShowSynopsis(false);
    setTimerRunning(false);
    setViewMode("archive");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const formatTimer = (totalSeconds) => {
    const mins = Math.floor(totalSeconds / 60);
    const secs = totalSeconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const countWords = (text) => {
    const trimmed = text.trim();
    if (!trimmed) return 0;
    return trimmed.split(/\s+/).filter(Boolean).length;
  };

  // Reactions handler
  const handleReaction = (qId, type) => {
    setReactions((prev) => {
      const qReactions = prev[qId] || {
        helpful: 14,
        easy: 4,
        relevant: 22,
        new: 9,
        confusing: 1,
        userVoted: null,
      };

      if (qReactions.userVoted === type) {
        return {
          ...prev,
          [qId]: {
            ...qReactions,
            [type]: Math.max(0, qReactions[type] - 1),
            userVoted: null,
          },
        };
      }

      const updated = { ...qReactions };
      if (qReactions.userVoted) {
        updated[qReactions.userVoted] = Math.max(
          0,
          updated[qReactions.userVoted] - 1
        );
      }
      updated[type] = (updated[type] || 0) + 1;
      updated.userVoted = type;

      return { ...prev, [qId]: updated };
    });
  };

  // Post comment / submit answer
  const handlePostAnswer = (e) => {
    e.preventDefault();
    const errors = {};
    if (!commentText.trim()) {
      errors.comment = "Please write your answer or comment before submitting.";
    }
    if (!candidateName.trim()) {
      errors.name = "Please enter your name.";
    }
    if (!candidateEmail.trim()) {
      errors.email = "Please enter your email or phone number.";
    }
    if (!isOver18) {
      errors.age = "You must confirm you are 18 years or older to participate.";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    const newComment = {
      id: "c_" + Date.now(),
      author: candidateName.trim(),
      initial: candidateName.trim().charAt(0).toUpperCase() || "A",
      time: "Just now",
      text: commentText.trim(),
      likes: 1,
      replies: 0,
      userLiked: true,
      attachment: uploadedAttachment?.name,
    };

    if (activeQuestion) {
      setDiscussions((prev) => ({
        ...prev,
        [activeQuestion.id]: [newComment, ...(prev[activeQuestion.id] || [])],
      }));
    }

    setCommentText("");
    setUploadedAttachment(null);
    setFormErrors({});
    alert("Answer posted successfully! Your answer is visible to mentors and peer aspirants.");
  };

  // Formatting helpers for text toolbar
  const insertFormatting = (tag) => {
    setCommentText((prev) => {
      switch (tag) {
        case "b":
          return prev + " **bold text** ";
        case "i":
          return prev + " *italic text* ";
        case "u":
          return prev + " <u>underlined text</u> ";
        case "s":
          return prev + " ~~strikethrough~~ ";
        case "code":
          return prev + "\n```\ncode block\n```\n";
        case "quote":
          return prev + "\n> quoted argument\n";
        case "link":
          return prev + " [Source Link](https://) ";
        default:
          return prev;
      }
    });
  };

  // =========================================================================
  // VIEW 1: MAINS ARCHIVE & DATE LISTING VIEW (Exact Match to Images 1, 2, 3)
  // =========================================================================
  if (viewMode === "archive") {
    return (
      <div className="space-y-10 max-w-7xl mx-auto px-2 sm:px-4">
        {/* ================= HERO SECTION (Image 1) ================= */}
        <div className="bg-[#0e1726] rounded-3xl p-6 sm:p-10 lg:p-12 text-white shadow-2xl relative overflow-hidden border border-slate-800">
          {/* Subtle background glow */}
          <div className="absolute top-0 right-1/4 w-96 h-96 bg-red-900/20 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute bottom-0 right-0 w-80 h-80 bg-blue-900/10 rounded-full blur-3xl pointer-events-none" />

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start relative z-10">
            {/* Left Column: Heading, intro & feature pills */}
            <div className="lg:col-span-7 space-y-6">
              {/* Badges */}
              <div className="flex flex-wrap items-center gap-2.5">
                <span className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs font-bold bg-[#dc2626] text-white shadow-sm">
                  <Check size={14} className="stroke-[3]" />
                  <span>100% FREE Expert Evaluation & Feedback</span>
                </span>
                <span className="px-3.5 py-1.5 rounded-full text-xs font-bold tracking-wider uppercase bg-[#1f293d] text-red-400 border border-red-500/30">
                  INSIGHTS IAS MAINS SECURE INITIATIVE 2026
                </span>
              </div>

              {/* Main Heading */}
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white leading-tight tracking-tight">
                UPSC Mains Answer Writing{" "}
                <span className="text-[#fbbf24] font-serif italic font-normal">
                  Practice 2026
                </span>
              </h1>

              {/* Paragraphs */}
              <div className="space-y-4 text-slate-300 text-xs sm:text-sm leading-relaxed">
                <p>
                  India's <strong className="text-white font-bold">first daily answer writing programme</strong> for UPSC Mains, running strong since <strong className="text-white font-bold">2014</strong>. Every <strong className="text-white font-bold">Monday to Saturday</strong>, carefully selected questions are posted covering <strong className="text-white font-bold">GS 1, 2, 3 and 4</strong>, with expert feedback from the Insights IAS team.
                </p>
                <p>
                  That is exactly what <strong className="text-[#fbbf24] font-bold">thousands of IAS and IPS toppers</strong> have done through SECURE as part of their daily routine. And the best part? It is <strong className="text-white font-bold">completely free</strong>, open to every aspirant across India.
                </p>
              </div>

              {/* 4 Feature Pills in a Grid */}
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5 pt-2">
                <div className="bg-slate-800/80 border border-slate-700/60 p-3 rounded-2xl flex items-center gap-3">
                  <FileText className="text-[#fbbf24] flex-shrink-0" size={20} />
                  <div>
                    <span className="text-xs font-black text-white block">GS 1–4</span>
                    <span className="text-[10px] text-slate-400 font-bold tracking-wider uppercase">ALL PAPERS</span>
                  </div>
                </div>

                <div className="bg-slate-800/80 border border-slate-700/60 p-3 rounded-2xl flex items-center gap-3">
                  <Zap className="text-[#fbbf24] flex-shrink-0" size={20} />
                  <div>
                    <span className="text-xs font-black text-white block">Fastest</span>
                    <span className="text-[10px] text-slate-400 font-bold tracking-wider uppercase">EVALUATION</span>
                  </div>
                </div>

                <div className="bg-slate-800/80 border border-slate-700/60 p-3 rounded-2xl flex items-center gap-3">
                  <Lock className="text-[#fbbf24] flex-shrink-0" size={20} />
                  <div>
                    <span className="text-xs font-black text-white block">Free</span>
                    <span className="text-[10px] text-slate-400 font-bold tracking-wider uppercase">ALWAYS</span>
                  </div>
                </div>

                <div className="bg-slate-800/80 border border-slate-700/60 p-3 rounded-2xl flex items-center gap-3">
                  <Layers className="text-[#fbbf24] flex-shrink-0" size={20} />
                  <div>
                    <span className="text-xs font-black text-white block truncate">Current Affairs</span>
                    <span className="text-[10px] text-slate-400 font-bold tracking-wider uppercase">+ STATIC SYLLABUS</span>
                  </div>
                </div>
              </div>

              {/* Learn How SECURE Works Button */}
              <div className="pt-2">
                <button
                  onClick={() => setActiveModal("learn-secure")}
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-slate-800 hover:bg-slate-700 text-white text-xs font-bold border border-slate-600 transition-all active:scale-95 cursor-pointer"
                >
                  <Play size={13} className="fill-[#fbbf24] text-[#fbbf24]" />
                  <span>New here? Learn how SECURE works</span>
                </button>
              </div>
            </div>

            {/* Right Column: Featured Course Banners (Image 1) */}
            <div className="lg:col-span-5 space-y-4">
              {/* Featured Course 1 */}
              <div className="bg-slate-800/70 border border-slate-700 rounded-2xl p-5 space-y-3 relative hover:border-slate-600 transition-all">
                <div className="flex items-center justify-between">
                  <span className="bg-[#dc2626] text-white text-[10px] font-black uppercase tracking-wider px-2 py-0.5 rounded">
                    FEATURED
                  </span>
                </div>
                <h3 className="font-extrabold text-sm sm:text-base text-white leading-snug">
                  Public Administration 2027 Batch 1 Optional (Offline/Online)
                </h3>
                <div className="flex flex-wrap items-center gap-2 text-[10px] text-slate-300">
                  <span className="bg-slate-900/80 border border-slate-700 px-2 py-0.5 rounded">
                    Current affairs integration
                  </span>
                  <span className="bg-slate-900/80 border border-slate-700 px-2 py-0.5 rounded">
                    Answer writing
                  </span>
                  <span className="bg-slate-900/80 border border-slate-700 px-2 py-0.5 rounded font-mono text-[#fbbf24]">
                    ₹28,800 (Offer)
                  </span>
                </div>
                <a
                  href="/courses"
                  className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-lg bg-white hover:bg-slate-100 text-slate-900 text-xs font-black tracking-wider uppercase transition-all shadow-sm"
                >
                  <span>ENROLL</span>
                  <ArrowRight size={13} />
                </a>
              </div>

              {/* Featured Course 2 */}
              <div className="bg-slate-800/70 border border-slate-700 rounded-2xl p-5 space-y-3 relative hover:border-slate-600 transition-all">
                <div className="flex items-center justify-between">
                  <span className="bg-[#ea580c] text-white text-[10px] font-black uppercase tracking-wider px-2 py-0.5 rounded">
                    NEW BATCH
                  </span>
                </div>
                <h3 className="font-extrabold text-sm sm:text-base text-white leading-snug">
                  OGP 2027 Batch 5 (Offline/Online)
                </h3>
                <div className="flex flex-wrap items-center gap-2 text-[10px] text-slate-300">
                  <span className="bg-slate-900/80 border border-slate-700 px-2 py-0.5 rounded">
                    one-on-one mentorship
                  </span>
                  <span className="bg-slate-900/80 border border-slate-700 px-2 py-0.5 rounded">
                    Daily Prelims & Mains
                  </span>
                </div>
                <p className="text-[11px] text-slate-400 font-mono">
                  Online: ₹90,000 & Offline: ₹1,24,200 (Offer)
                </p>
                <a
                  href="/courses"
                  className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-lg bg-white hover:bg-slate-100 text-slate-900 text-xs font-black tracking-wider uppercase transition-all shadow-sm"
                >
                  <span>ENROLL</span>
                  <ArrowRight size={13} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* ================= QUICK ACTION CARDS (Image 2) ================= */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div
            onClick={() => setActiveModal("how-to")}
            className="bg-white p-4 rounded-2xl border border-slate-200 hover:border-red-400 hover:shadow-md transition-all cursor-pointer flex items-center justify-between gap-3 group"
          >
            <div className="flex items-center gap-3.5 min-w-0">
              <div className="w-10 h-10 rounded-xl bg-[#c83a2a] text-white flex items-center justify-center flex-shrink-0 shadow-xs group-hover:scale-105 transition-transform">
                <Lightbulb size={20} className="fill-white/20" />
              </div>
              <span className="text-xs font-bold text-slate-800 group-hover:text-red-900 transition-colors leading-snug">
                How to Use SECURE and Get Evaluated
              </span>
            </div>
            <div className="w-6 h-6 rounded-full bg-slate-50 border border-slate-200 flex items-center justify-center flex-shrink-0 text-slate-400 group-hover:text-red-900 group-hover:border-red-300 transition-colors">
              <ChevronRight size={14} />
            </div>
          </div>

          <div
            onClick={() => setActiveModal("timetable")}
            className="bg-white p-4 rounded-2xl border border-slate-200 hover:border-red-400 hover:shadow-md transition-all cursor-pointer flex items-center justify-between gap-3 group"
          >
            <div className="flex items-center gap-3.5 min-w-0">
              <div className="w-10 h-10 rounded-xl bg-[#c83a2a] text-white flex items-center justify-center flex-shrink-0 shadow-xs group-hover:scale-105 transition-transform">
                <Calendar size={20} />
              </div>
              <span className="text-xs font-bold text-slate-800 group-hover:text-red-900 transition-colors leading-snug">
                Mission 2026 Timetable
              </span>
            </div>
            <div className="w-6 h-6 rounded-full bg-slate-50 border border-slate-200 flex items-center justify-center flex-shrink-0 text-slate-400 group-hover:text-red-900 group-hover:border-red-300 transition-colors">
              <ChevronRight size={14} />
            </div>
          </div>

          <div
            onClick={() => setActiveModal("booklet")}
            className="bg-white p-4 rounded-2xl border border-slate-200 hover:border-red-400 hover:shadow-md transition-all cursor-pointer flex items-center justify-between gap-3 group"
          >
            <div className="flex items-center gap-3.5 min-w-0">
              <div className="w-10 h-10 rounded-xl bg-[#c83a2a] text-white flex items-center justify-center flex-shrink-0 shadow-xs group-hover:scale-105 transition-transform">
                <FileText size={20} />
              </div>
              <span className="text-xs font-bold text-slate-800 group-hover:text-red-900 transition-colors leading-snug">
                Specimen Q&A Booklets
              </span>
            </div>
            <div className="w-6 h-6 rounded-full bg-slate-50 border border-slate-200 flex items-center justify-center flex-shrink-0 text-slate-400 group-hover:text-red-900 group-hover:border-red-300 transition-colors">
              <ChevronRight size={14} />
            </div>
          </div>

          <div
            onClick={() => setActiveModal("self-eval")}
            className="bg-white p-4 rounded-2xl border border-slate-200 hover:border-red-400 hover:shadow-md transition-all cursor-pointer flex items-center justify-between gap-3 group"
          >
            <div className="flex items-center gap-3.5 min-w-0">
              <div className="w-10 h-10 rounded-xl bg-[#c83a2a] text-white flex items-center justify-center flex-shrink-0 shadow-xs group-hover:scale-105 transition-transform">
                <CheckCircle2 size={20} />
              </div>
              <span className="text-xs font-bold text-slate-800 group-hover:text-red-900 transition-colors leading-snug">
                Self Evaluation Guide
              </span>
            </div>
            <div className="w-6 h-6 rounded-full bg-slate-50 border border-slate-200 flex items-center justify-center flex-shrink-0 text-slate-400 group-hover:text-red-900 group-hover:border-red-300 transition-colors">
              <ChevronRight size={14} />
            </div>
          </div>
        </div>

        {/* ================= FILTER & SEARCH BAR (Image 2) ================= */}
        <div className="space-y-3">
          <div className="flex flex-col md:flex-row md:items-center gap-3 bg-white p-4 rounded-2xl border border-slate-200/90 shadow-2xs">
            {/* Year Filter */}
            <div className="flex items-center gap-2">
              <span className="text-xs font-black uppercase text-slate-400 tracking-wider">YEAR</span>
              <select
                value={yearFilter}
                onChange={(e) => setYearFilter(e.target.value)}
                className="bg-slate-50 border border-slate-200 px-3 py-2 rounded-xl text-xs font-bold text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-900/20 cursor-pointer"
              >
                <option value="2026">2026</option>
                <option value="2025">2025</option>
                <option value="All">All Years</option>
              </select>
            </div>

            {/* Month Filter */}
            <div className="flex items-center gap-2">
              <span className="text-xs font-black uppercase text-slate-400 tracking-wider">MONTH</span>
              <select
                value={monthFilter}
                onChange={(e) => setMonthFilter(e.target.value)}
                className="bg-slate-50 border border-slate-200 px-3 py-2 rounded-xl text-xs font-bold text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-900/20 cursor-pointer"
              >
                <option value="All">All Months</option>
                <option value="November">November</option>
                <option value="October">October</option>
                <option value="September">September</option>
                <option value="August">August</option>
              </select>
            </div>

            {/* Search Input */}
            <div className="relative flex-1">
              <Search
                size={16}
                className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400"
              />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search Secure Articles..."
                className="w-full pl-9 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs font-medium text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-900/20 focus:border-red-900"
              />
            </div>
          </div>

          {/* Subject Folders Bar */}
          <div className="bg-white rounded-2xl p-4 border border-slate-200/90 shadow-2xs">
            <div className="flex items-center justify-between mb-2.5">
              <div className="flex items-center gap-2">
                <Folder size={15} className="text-red-700" />
                <span className="text-xs font-bold text-slate-900 uppercase tracking-wider">
                  Browse by Subject Folder
                </span>
                <span className="text-[11px] font-medium text-slate-400">
                  ({mainsSubjectFolders.length - 1} folders)
                </span>
              </div>
              {folderFilter !== "All" && (
                <button
                  type="button"
                  onClick={() => setFolderFilter("All")}
                  className="text-xs font-bold text-red-600 hover:text-red-700 hover:underline cursor-pointer"
                >
                  Show All Folders
                </button>
              )}
            </div>
            <div className="flex items-center gap-2 overflow-x-auto pb-1 no-scrollbar">
              {mainsSubjectFolders.map((f) => {
                const isSelected = folderFilter === f;
                return (
                  <button
                    key={f}
                    type="button"
                    onClick={() => setFolderFilter(f)}
                    className={`px-3 py-1.5 rounded-xl text-xs font-bold whitespace-nowrap transition-all cursor-pointer flex items-center gap-1.5 ${
                      isSelected
                        ? "bg-red-900 text-white shadow-xs scale-102"
                        : "bg-slate-50 hover:bg-slate-100 text-slate-700 border border-slate-200/80"
                    }`}
                  >
                    <Folder size={11} className={isSelected ? "text-red-200" : "text-red-700"} />
                    <span>{f}</span>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="flex items-center justify-between text-xs font-bold text-slate-700 px-1">
            <div className="flex items-center gap-2">
              <span>{filteredArchiveArticles.length}</span>{" "}
              <span className="font-normal text-slate-500">Secure practice dates found</span>
              {folderFilter !== "All" && (
                <span className="text-[11px] font-bold px-2 py-0.5 rounded-md bg-red-100 text-red-900 border border-red-200">
                  Folder: {folderFilter}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* ================= MAIN CONTENT: 2 COLUMNS (Images 2 & 3) ================= */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          {/* LEFT COLUMN: Date Articles Grouped by Month */}
          <div className="lg:col-span-8 space-y-8">
            {Object.keys(groupedArticles).length === 0 ? (
              <div className="bg-white p-12 text-center rounded-2xl border border-slate-200 text-slate-400 text-xs">
                No Secure practice articles found matching your filters.
              </div>
            ) : (
              Object.entries(groupedArticles).map(([monthLabel, items]) => (
                <div key={monthLabel} className="space-y-4">
                  {/* Month Heading */}
                  <div className="flex items-center gap-2 border-b border-slate-200/80 pb-2">
                    <span className="w-2.5 h-2.5 rounded-full bg-[#dc2626]" />
                    <h2 className="text-xs font-extrabold uppercase tracking-wider text-slate-800">
                      {monthLabel}
                    </h2>
                  </div>

                  {/* List of Date Cards */}
                  <div className="space-y-3">
                    {items.map((art) => (
                      <div
                        key={art.date}
                        onClick={() => handleOpenDateArticle(art.date)}
                        className="bg-white p-4 sm:p-5 rounded-2xl border border-slate-200/90 hover:border-red-400/80 hover:shadow-md transition-all cursor-pointer flex items-center gap-4 sm:gap-6 group"
                      >
                        {/* Big Day & Month Block */}
                        <div className="w-14 text-center flex-shrink-0">
                          <span className="block text-2xl sm:text-3xl font-black text-slate-900 group-hover:text-red-900 transition-colors leading-none">
                            {art.day}
                          </span>
                          <span className="block text-[10px] font-extrabold uppercase text-slate-500 tracking-wider mt-1">
                            {art.month}
                          </span>
                        </div>

                        {/* Vertical Red Divider */}
                        <div className="w-0.5 h-10 bg-red-100 group-hover:bg-red-400 transition-colors flex-shrink-0" />

                        {/* Middle Content: Title, Folder & Date */}
                        <div className="flex-1 min-w-0">
                          <h3 className="font-serif text-sm sm:text-base font-bold text-slate-900 group-hover:text-red-900 transition-colors line-clamp-2 leading-snug">
                            {art.title}
                          </h3>
                          <div className="flex items-center gap-2 mt-2 flex-wrap">
                            <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[10px] font-bold bg-red-50 text-red-950 border border-red-200">
                              <Folder size={10} className="text-red-700" />
                              {art.folder || allQuestions.find((q) => q.date === art.date)?.folder || allQuestions.find((q) => q.date === art.date)?.subject || (art.title.includes("Mini") ? "Ethics & Integrity" : "Indian Polity")}
                            </span>
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] font-medium text-slate-500 bg-slate-50 border border-slate-200">
                              <Calendar size={10} className="text-slate-400" />
                              <span>{art.formattedDate}</span>
                            </span>
                          </div>
                        </div>

                        {/* Right Badge */}
                        <div className="flex-shrink-0">
                          <span className="inline-block px-2.5 py-1 rounded text-[10px] font-extrabold uppercase tracking-wider bg-red-50 text-red-900 border border-red-200">
                            {art.badge}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            )}
          </div>

          {/* RIGHT COLUMN: Answer Writing Tips Sticky Card (Images 2 & 3) */}
          <div className="lg:col-span-4 sticky top-24 space-y-4">
            <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-xs space-y-6">
              {/* Header */}
              <div className="flex items-center gap-2 pb-3 border-b border-slate-100">
                <span className="w-1 h-5 bg-[#dc2626] rounded-full" />
                <h3 className="text-xs font-black uppercase tracking-wider text-slate-900">
                  ANSWER WRITING TIPS
                </h3>
              </div>

              {/* Numbered Tips (1 to 8) */}
              <div className="space-y-4 text-xs text-slate-700 leading-relaxed">
                {/* Tip 1 */}
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-[#dc2626] text-white font-extrabold text-xs flex items-center justify-center flex-shrink-0 mt-0.5 shadow-2xs">
                    1
                  </div>
                  <div>
                    <strong className="text-slate-900 block font-bold mb-0.5">Strict Timing</strong>
                    <p className="text-slate-600 text-[11px]">
                      Limit 10-markers to 7 minutes and 15-markers to 10 minutes. Speed with precision is what UPSC rewards.
                    </p>
                  </div>
                </div>

                {/* Tip 2 */}
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-[#dc2626] text-white font-extrabold text-xs flex items-center justify-center flex-shrink-0 mt-0.5 shadow-2xs">
                    2
                  </div>
                  <div>
                    <strong className="text-slate-900 block font-bold mb-0.5">Structural Hierarchy</strong>
                    <p className="text-slate-600 text-[11px]">
                      Every answer needs a crisp Introduction, well-organised Body with subheadings or bullets, and a forward-looking Conclusion.
                    </p>
                  </div>
                </div>

                {/* Tip 3 */}
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-[#dc2626] text-white font-extrabold text-xs flex items-center justify-center flex-shrink-0 mt-0.5 shadow-2xs">
                    3
                  </div>
                  <div>
                    <strong className="text-slate-900 block font-bold mb-0.5">Current Affairs Integration</strong>
                    <p className="text-slate-600 text-[11px]">
                      Link static syllabus content with recent events — exactly how UPSC frames questions.
                    </p>
                  </div>
                </div>

                {/* Tip 4 */}
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-[#dc2626] text-white font-extrabold text-xs flex items-center justify-center flex-shrink-0 mt-0.5 shadow-2xs">
                    4
                  </div>
                  <div>
                    <strong className="text-slate-900 block font-bold mb-0.5">Write Daily Without Fail</strong>
                    <p className="text-slate-600 text-[11px]">
                      Consistency over brilliance. One serious answer a day beats weekend marathons.
                    </p>
                  </div>
                </div>

                {/* Tip 5 */}
                <div className="pt-2 text-slate-700 text-xs leading-relaxed">
                  <span className="font-bold text-[#dc2626] mr-1.5 text-xs">5.</span>
                  Upload pages in the <strong className="text-slate-900 font-semibold">correct order</strong> and ensure <strong className="text-slate-900 font-semibold">photos are clear and well-lit</strong> for accurate evaluation.
                </div>

                {/* Tip 6 */}
                <div className="pt-2 text-slate-700 text-xs leading-relaxed">
                  <span className="font-bold text-[#dc2626] mr-1.5 text-xs">6.</span>
                  You can upload <strong className="text-slate-900 font-semibold">at any time</strong>. Our expert team will evaluate and share feedback whenever you submit.
                </div>

                {/* Tip 7 */}
                <div className="pt-2 text-slate-700 text-xs leading-relaxed">
                  <span className="font-bold text-[#dc2626] mr-1.5 text-xs">7.</span>
                  <strong className="text-slate-900 font-semibold">Review your feedback</strong>, identify gaps and rewrite if needed.
                </div>

                {/* Tip 8 */}
                <div className="pt-2 text-slate-700 text-xs leading-relaxed">
                  <span className="font-bold text-[#dc2626] mr-1.5 text-xs">8.</span>
                  <strong className="text-slate-900 font-semibold">Repeat every day</strong>. That daily habit builds toppers.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ================= MODALS ================= */}
        {activeModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs animate-fadeIn">
            <div className="bg-white rounded-3xl max-w-2xl w-full p-6 sm:p-8 max-h-[85vh] overflow-y-auto space-y-6 shadow-2xl border border-slate-200 relative">
              <button
                onClick={() => setActiveModal(null)}
                className="absolute top-5 right-5 p-2 rounded-full hover:bg-slate-100 text-slate-400 hover:text-slate-700 transition-colors"
              >
                <X size={18} />
              </button>

              {activeModal === "how-to" && (
                <div className="space-y-4 text-xs text-slate-700">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-red-900 bg-red-50 px-2.5 py-1 rounded">
                    GUIDELINES & SUBMISSION
                  </span>
                  <h3 className="text-xl font-bold text-slate-900">
                    How to Use SECURE and Get Evaluated
                  </h3>
                  <div className="space-y-3 leading-relaxed">
                    <p>
                      <strong>1. Daily Question Posting:</strong> Selected GS 1, 2, 3, and 4 questions are posted at 9:00 AM every Monday to Saturday based on daily editorials and static syllabus.
                    </p>
                    <p>
                      <strong>2. Write on UPSC Standard QCAB Pages:</strong> Write on A4 sheets with 1-inch margins on both sides.
                    </p>
                    <p>
                      <strong>3. Time Your Answer:</strong> Strictly adhere to 7 minutes for 10-markers (150 words) and 11 minutes for 15-markers (250 words).
                    </p>
                    <p>
                      <strong>4. Upload Clear Photos / PDF:</strong> Click on any question, scroll down to the answer submission box, and upload your pages.
                    </p>
                    <p>
                      <strong>5. Mentor & Peer Feedback:</strong> Qualified faculty will evaluate your submission, provide marks, and detail strengths and gaps.
                    </p>
                  </div>
                </div>
              )}

              {activeModal === "timetable" && (
                <div className="space-y-4 text-xs text-slate-700">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-red-900 bg-red-50 px-2.5 py-1 rounded">
                    SYLLABUS DISTRIBUTION
                  </span>
                  <h3 className="text-xl font-bold text-slate-900">
                    Mission 2026: Mains Yearlong Timetable
                  </h3>
                  <div className="space-y-2 border border-slate-200 rounded-xl divide-y divide-slate-100">
                    <div className="p-3 flex items-center justify-between">
                      <strong className="text-slate-900">Monday</strong>
                      <span className="text-slate-600">GS Paper I (History, Geography, Indian Society)</span>
                    </div>
                    <div className="p-3 flex items-center justify-between">
                      <strong className="text-slate-900">Tuesday</strong>
                      <span className="text-slate-600">GS Paper II (Polity, Constitution, Governance, IR)</span>
                    </div>
                    <div className="p-3 flex items-center justify-between">
                      <strong className="text-slate-900">Wednesday</strong>
                      <span className="text-slate-600">GS Paper III (Economy, Science & Tech, Environment, Security)</span>
                    </div>
                    <div className="p-3 flex items-center justify-between">
                      <strong className="text-slate-900">Thursday</strong>
                      <span className="text-slate-600">GS Paper IV (Ethics, Integrity, Aptitude & Case Studies)</span>
                    </div>
                    <div className="p-3 flex items-center justify-between">
                      <strong className="text-slate-900">Friday</strong>
                      <span className="text-slate-600">Current Affairs Linking & Contemporary Essay Drills</span>
                    </div>
                    <div className="p-3 flex items-center justify-between">
                      <strong className="text-slate-900">Saturday</strong>
                      <span className="text-slate-600">Mini SECURE (Weekly Full-Length Review Drill)</span>
                    </div>
                  </div>
                </div>
              )}

              {activeModal === "booklet" && (
                <div className="space-y-4 text-xs text-slate-700">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-red-900 bg-red-50 px-2.5 py-1 rounded">
                    EXAM FORMATTING
                  </span>
                  <h3 className="text-xl font-bold text-slate-900">
                    Specimen Q&A Booklets (QCAB Standard)
                  </h3>
                  <p className="leading-relaxed">
                    UPSC civil services mains requires writing inside Question Paper-cum-Answer Booklets (QCAB) with fixed margins and page allocations.
                  </p>
                  <ul className="list-disc pl-5 space-y-2">
                    <li>10-Markers: 2 printed pages allocated. (~150 words)</li>
                    <li>15-Markers: 3 printed pages allocated. (~250 words)</li>
                    <li>Left and right margins must be left strictly blank for examiner marks.</li>
                  </ul>
                </div>
              )}

              {activeModal === "self-eval" && (
                <div className="space-y-4 text-xs text-slate-700">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-red-900 bg-red-50 px-2.5 py-1 rounded">
                    EVALUATION BENCHMARK
                  </span>
                  <h3 className="text-xl font-bold text-slate-900">
                    Self-Evaluation & Peer Review Rubric
                  </h3>
                  <div className="space-y-3">
                    <div className="p-3 bg-slate-50 rounded-xl border border-slate-200">
                      <strong className="text-slate-900 block">1. Directive Compliance (25%)</strong>
                      <span className="text-slate-600 text-[11px]">Did you directly address 'Critically Examine', 'Discuss', or 'Evaluate'?</span>
                    </div>
                    <div className="p-3 bg-slate-50 rounded-xl border border-slate-200">
                      <strong className="text-slate-900 block">2. Multidimensional Body (40%)</strong>
                      <span className="text-slate-600 text-[11px]">Subdivided into Social, Economic, Political, Environmental, and International aspects.</span>
                    </div>
                    <div className="p-3 bg-slate-50 rounded-xl border border-slate-200">
                      <strong className="text-slate-900 block">3. Contemporary Value Addition (20%)</strong>
                      <span className="text-slate-600 text-[11px]">Reports, committees, constitutional articles, and recent landmark verdicts.</span>
                    </div>
                    <div className="p-3 bg-slate-50 rounded-xl border border-slate-200">
                      <strong className="text-slate-900 block">4. Way Forward & Conclusion (15%)</strong>
                      <span className="text-slate-600 text-[11px]">Constructive, solution-oriented closing.</span>
                    </div>
                  </div>
                </div>
              )}

              {activeModal === "learn-secure" && (
                <div className="space-y-4 text-xs text-slate-700">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-red-900 bg-red-50 px-2.5 py-1 rounded">
                    ABOUT SECURE INITIATIVE
                  </span>
                  <h3 className="text-xl font-bold text-slate-900">
                    How SECURE Transforms UPSC Preparation
                  </h3>
                  <p className="leading-relaxed">
                    Started in 2014, the SECURE initiative is designed to instill daily answer-writing discipline. By practicing every single day from Monday to Saturday, aspirants internalize time management, structural hierarchy, and multidimensional analysis.
                  </p>
                  <p className="leading-relaxed">
                    Click any date from the list to view that day's questions. Write your answer, post it in the discussion section, review synopses, and receive feedback from mentors!
                  </p>
                </div>
              )}

              <div className="pt-2 flex justify-end">
                <button
                  onClick={() => setActiveModal(null)}
                  className="px-5 py-2 bg-slate-900 hover:bg-slate-800 text-white font-bold rounded-xl text-xs"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // =========================================================================
  // VIEW 2: QUESTION LIST FOR SELECTED DATE (Opened upon clicking a date)
  // =========================================================================
  if (viewMode === "questions") {
    const selectedArticle = archiveArticles.find((a) => a.date === selectedDate);
    const dateTitle = selectedArticle?.title || `UPSC Mains Answer Writing Practice – Insights SECURE: ${selectedDate}`;

    return (
      <div className="space-y-6 max-w-5xl mx-auto px-2 sm:px-4 animate-fadeIn">
        {/* Top Back to Archive Navigation */}
        <div className="flex items-center justify-between">
          <button
            onClick={backToArchive}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-white hover:bg-slate-100 text-slate-800 text-xs font-bold border border-slate-200 shadow-2xs transition-all active:scale-95 cursor-pointer"
          >
            <ArrowLeft size={15} />
            <span>Back to All Mains Practice Dates</span>
          </button>

          <span className="text-xs font-bold text-slate-500">
            {dateQuestions.length} Questions for this Edition
          </span>
        </div>

        {/* Main Card with Date Header */}
        <div className="bg-white rounded-3xl shadow-sm border border-slate-200 p-6 md:p-12 space-y-8">
          {/* Article Header & Date Selector */}
          <div className="space-y-4 pb-6 border-b border-slate-200">
            <div className="flex flex-wrap items-center justify-between gap-4">
              <span className="text-xs uppercase font-extrabold tracking-wider bg-red-100 text-[#7b0000] px-3.5 py-1.5 rounded-full">
                SECURE Initiative • UPSC Mains 2026/2027
              </span>

              {/* Date Picker Switcher */}
              <div className="flex items-center gap-2 bg-slate-50 border border-slate-200 px-3 py-1.5 rounded-xl">
                <Calendar size={14} className="text-[#7b0000]" />
                <span className="text-xs font-bold text-slate-700">Edition:</span>
                <select
                  value={selectedDate}
                  onChange={(e) => {
                    setSelectedDate(e.target.value);
                    setSelectedQuestionId(null);
                  }}
                  className="bg-transparent text-xs font-bold text-slate-900 focus:outline-none cursor-pointer"
                >
                  {archiveArticles.map((a) => (
                    <option key={a.date} value={a.date}>
                      {a.day} {a.month} {a.year} ({a.badge})
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-slate-900 leading-tight">
              {dateTitle}
            </h1>

            <div className="flex items-center gap-4 text-xs text-slate-500 font-medium">
              <span>
                Posted for <strong className="text-slate-700">{selectedArticle?.formattedDate || selectedDate}</strong>
              </span>
              <span>•</span>
              <span>
                By <strong className="text-slate-700">Insights Editor / Selva's IAS</strong>
              </span>
              <span>•</span>
              <span className="flex items-center gap-1 text-slate-600">
                <Printer size={13} /> Print Friendly, PDF & Email
              </span>
            </div>
          </div>

          {/* Editorial Introduction Text */}
          <div className="text-slate-700 text-sm md:text-base leading-relaxed space-y-4">
            <p>
              The Insights IAS Secure Initiative for UPSC Mains Answer Writing practice enables you to practice daily answer writing, enhancing your skills and boosting your scores with regular feedback, expert tips, and strategies. Let consistency be the hallmark of your preparation and utilize UPSC Mains Answer Writing practice initiative wisely.
            </p>

            <p className="text-center font-bold text-slate-900 pt-2 pb-1">
              <span className="underline decoration-[#7b0000] decoration-2 underline-offset-4">
                Click on EACH question to post/upload your answers.
              </span>
            </p>

            {/* Guidelines Links */}
            <div className="space-y-1.5 text-xs md:text-sm font-bold text-red-600">
              <div>
                <button onClick={() => setActiveModal("how-to")} className="hover:underline flex items-center gap-1.5 cursor-pointer">
                  • How to Follow Secure Initiative?
                </button>
              </div>
              <div>
                <button onClick={() => setActiveModal("self-eval")} className="hover:underline flex items-center gap-1.5 cursor-pointer">
                  • How to Self-evaluate your answer?
                </button>
              </div>
              <div>
                <button onClick={() => setActiveModal("timetable")} className="hover:underline flex items-center gap-1.5 cursor-pointer">
                  • MISSION – 2026: YEARLONG TIMETABLE
                </button>
              </div>
            </div>
          </div>

          {/* Questions Organized by General Studies Papers */}
          <div className="space-y-10 pt-4">
            {gsPapers.map((paperGroup) => {
              const paperQuestions = dateQuestions.filter(
                (q) => q.paper === paperGroup.code
              );

              if (paperQuestions.length === 0) return null;

              return (
                <div key={paperGroup.code} className="space-y-5">
                  {/* Clean Centered Header with Top/Bottom Divider Line */}
                  <div className="border-t border-b border-slate-300 py-3 text-center bg-slate-50/70 rounded-lg">
                    <h2 className="text-lg md:text-xl font-extrabold text-slate-900 tracking-wide uppercase">
                      {paperGroup.title}
                    </h2>
                  </div>

                  {/* Blue Clickable Questions List */}
                  <div className="space-y-4 pl-1 md:pl-2">
                    {paperQuestions.map((q) => (
                      <div
                        key={q.id}
                        onClick={() => openQuestionDetail(q.id)}
                        className="group cursor-pointer p-3.5 rounded-xl hover:bg-blue-50/60 transition-all border border-transparent hover:border-blue-200"
                      >
                        <p className="text-sm md:text-[15px] font-bold text-blue-700 group-hover:text-blue-900 leading-snug">
                          <span className="text-blue-800 font-extrabold mr-1.5">
                            {q.qNumber}.
                          </span>
                          “{q.question.replace(/^“|”$/g, "").replace(/\(\d+\s*M.*?\)/, "").trim()}”{" "}
                          <span className="font-semibold text-blue-600">
                            ({q.marks} M, {q.words} Words)
                          </span>
                        </p>
                        <div className="flex items-center gap-2 mt-2 text-xs text-slate-500 font-medium opacity-80 group-hover:opacity-100 flex-wrap">
                          <span className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-md bg-red-50 text-red-950 border border-red-200">
                            <Folder size={10} className="text-red-700" />
                            {q.folder || q.subject || "Indian Polity"}
                          </span>
                          <span className="text-slate-600 font-semibold">{q.subject}</span>
                          <span>•</span>
                          <span>{q.words} Words</span>
                          <span>•</span>
                          <span className="text-[#7b0000] font-bold flex items-center gap-1">
                            Click to write answer & view synopsis →
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Social Links Footer */}
          <div className="pt-8 border-t border-slate-200 text-xs text-slate-600 space-y-2">
            <p>
              Join our <strong>Official Telegram Channel</strong>{" "}
              <a href="#telegram" className="text-red-600 font-bold hover:underline">HERE</a>
            </p>
            <p>
              Subscribe to our <strong>YouTube Channel</strong>{" "}
              <a href="#youtube" className="text-red-600 font-bold hover:underline">HERE</a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  // =========================================================================
  // VIEW 3: QUESTION DETAIL & DISCUSSION VIEW (Single Question Drilldown)
  // =========================================================================
  const qReactions = reactions[activeQuestion.id] || {
    helpful: 14,
    easy: 4,
    relevant: 22,
    new: 9,
    confusing: 1,
    userVoted: null,
  };
  const totalReactions =
    qReactions.helpful +
    qReactions.easy +
    qReactions.relevant +
    qReactions.new +
    qReactions.confusing;

  const currentComments = discussions[activeQuestion.id] || [];
  const wordCount = countWords(commentText);

  return (
    <div className="bg-white rounded-3xl shadow-sm border border-slate-200 p-6 md:p-12 space-y-8 max-w-5xl mx-auto animate-fadeIn">
      {/* Top Back Navigation Bar */}
      <div className="flex items-center justify-between pb-4 border-b border-slate-200 flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <button
            onClick={backToDateQuestions}
            className="inline-flex items-center gap-1.5 text-xs md:text-sm font-bold text-[#7b0000] hover:text-[#5a0000] bg-red-50 hover:bg-red-100 px-3.5 py-1.5 rounded-xl transition shadow-2xs cursor-pointer"
          >
            <ArrowLeft size={15} /> Back to {activeQuestion.dateDisplay || selectedDate} Questions
          </button>
          <button
            onClick={backToArchive}
            className="text-xs text-slate-500 hover:text-slate-800 font-medium px-2 py-1 rounded-lg hover:bg-slate-50 cursor-pointer"
          >
            All Dates Archive
          </button>
        </div>

        <span className="text-xs font-bold text-slate-500">
          Question {currentIndex + 1} of {dateQuestions.length}
        </span>
      </div>

      {/* Main Title in Bold */}
      <div className="space-y-3">
        <h1 className="text-xl md:text-2xl lg:text-3xl font-extrabold text-slate-900 leading-snug">
          {activeQuestion.question.replace(/\(\d+\s*M.*?\)/, "").trim()}
        </h1>

        {/* Blue Subtitle Statement */}
        <p className="text-base md:text-lg font-bold text-blue-700">
          {activeQuestion.qNumber}. {activeQuestion.question}
        </p>

        {/* Category Tag, Folder Badge & Date */}
        <div className="pt-1 flex items-center gap-2 flex-wrap">
          <span className="inline-block text-xs font-bold text-blue-700 hover:text-blue-900 bg-blue-50 px-3 py-1 rounded-md border border-blue-200">
            Secure {activeQuestion.paper.replace("Paper ", "")}
          </span>
          <span className="inline-flex items-center gap-1 text-xs font-bold text-red-950 bg-red-50 px-3 py-1 rounded-md border border-red-200">
            <Folder size={12} className="text-red-700" />
            {activeQuestion.folder || activeQuestion.subject || "Indian Polity"}
          </span>
          <span className="inline-flex items-center gap-1 text-xs font-medium text-slate-600 bg-slate-50 px-2.5 py-1 rounded-md border border-slate-200">
            <Calendar size={12} className="text-slate-400" />
            {activeQuestion.dateDisplay || activeQuestion.date || "Today"}
          </span>
        </div>
      </div>

      {/* Syllabus Topic & Context Box */}
      <div className="bg-slate-50 rounded-2xl p-5 border border-slate-200 text-xs md:text-sm text-slate-700 space-y-2">
        <p>
          <strong className="text-red-700 font-bold uppercase tracking-wide">
            Topic:
          </strong>{" "}
          {activeQuestion.topic}
        </p>
        <p>
          <strong className="text-slate-900 font-bold">Reference:</strong>{" "}
          <span className="text-slate-600">{activeQuestion.reference}</span>
        </p>
        <p>
          <strong className="text-blue-900 font-bold">Why the question:</strong>{" "}
          <span className="text-slate-600">{activeQuestion.whyTheQuestion}</span>
        </p>
      </div>

      {/* Toggle Model Framework & Synopsis Button */}
      <div className="pt-1">
        <button
          onClick={() => setShowSynopsis(!showSynopsis)}
          className="w-full py-3 px-5 rounded-2xl bg-gradient-to-r from-blue-900 via-indigo-900 to-slate-900 text-white font-extrabold text-xs md:text-sm flex items-center justify-between shadow-md hover:shadow-lg transition cursor-pointer"
        >
          <span className="flex items-center gap-2">
            <Award size={18} className="text-amber-400" />
            {showSynopsis
              ? "Hide Structured Approach & Benchmark Model Synopsis"
              : "View Structured Approach & Benchmark Model Synopsis"}
          </span>
          {showSynopsis ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </button>

        {/* Expanded Model Framework & Synopsis */}
        {showSynopsis && (
          <div className="mt-4 p-6 bg-slate-50 border border-slate-200 rounded-2xl space-y-6 animate-fadeIn text-xs md:text-sm leading-relaxed">
            {/* Introduction Framework */}
            <div className="bg-white p-4 rounded-xl border border-slate-200 space-y-1">
              <strong className="text-blue-900 uppercase font-bold text-xs block">
                1. Introduction Approach (15% words):
              </strong>
              <p className="text-slate-700">{activeQuestion.framework.introduction}</p>
            </div>

            {/* Body Structure */}
            <div className="bg-white p-4 rounded-xl border border-slate-200 space-y-2">
              <strong className="text-blue-900 uppercase font-bold text-xs block">
                2. Body Arguments & Dimensions (70% words):
              </strong>
              <ul className="space-y-1.5 list-disc pl-5 text-slate-700">
                {activeQuestion.framework.body.map((item, bIdx) => (
                  <li key={bIdx}>{item}</li>
                ))}
              </ul>
            </div>

            {/* Conclusion */}
            <div className="bg-white p-4 rounded-xl border border-slate-200 space-y-1">
              <strong className="text-blue-900 uppercase font-bold text-xs block">
                3. Forward-Looking Conclusion (15% words):
              </strong>
              <p className="text-slate-700">{activeQuestion.framework.conclusion}</p>
            </div>

            {/* Model Synopsis */}
            <div className="bg-gradient-to-br from-amber-50 to-orange-50/50 p-5 rounded-xl border border-amber-200 space-y-3">
              <div className="flex items-center justify-between border-b border-amber-200/80 pb-2">
                <span className="font-extrabold text-amber-950 text-xs sm:text-sm flex items-center gap-2">
                  <Award size={16} className="text-amber-700" /> Benchmark Model Answer Synopsis
                </span>
                <span className="text-[10px] uppercase font-bold text-amber-800 bg-amber-100/80 px-2.5 py-0.5 rounded-full">
                  Faculty Benchmarked
                </span>
              </div>
              <p className="text-slate-800 font-serif leading-relaxed whitespace-pre-line text-xs sm:text-sm">
                {activeQuestion.modelSynopsis}
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Answer Writing Stopwatch Timer */}
      <div className="bg-slate-900 text-white rounded-2xl p-5 flex flex-col sm:flex-row items-center justify-between gap-4 shadow-md">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-amber-500/20 text-amber-400 flex items-center justify-center">
            <Clock size={20} />
          </div>
          <div>
            <span className="text-[10px] uppercase tracking-wider text-slate-400 block font-bold">
              Suggested Time: {activeQuestion.suggestedTime || "10 Minutes"}
            </span>
            <span className="text-2xl font-black font-mono text-amber-400">
              {formatTimer(timerSeconds)}
            </span>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => setTimerRunning(!timerRunning)}
            className={`px-4 py-2 rounded-xl text-xs font-bold transition ${
              timerRunning
                ? "bg-rose-600 hover:bg-rose-700 text-white"
                : "bg-emerald-600 hover:bg-emerald-700 text-white"
            }`}
          >
            {timerRunning ? "Pause Timer" : "Start Answer Timer"}
          </button>
          <button
            onClick={() => {
              setTimerRunning(false);
              setTimerSeconds(0);
            }}
            className="px-3 py-2 rounded-xl text-xs font-bold bg-slate-800 hover:bg-slate-700 text-slate-300"
          >
            Reset
          </button>
        </div>
      </div>

      {/* Question Reaction Feedback */}
      <div className="pt-2 flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 pb-4 text-xs">
        <span className="font-bold text-slate-600">
          How did you find this question? ({totalReactions} aspirants reacted)
        </span>

        <div className="flex flex-wrap items-center gap-2">
          <button
            onClick={() => handleReaction(activeQuestion.id, "helpful")}
            className={`px-3 py-1.5 rounded-lg border text-xs font-bold transition flex items-center gap-1.5 ${
              qReactions.userVoted === "helpful"
                ? "bg-emerald-50 border-emerald-300 text-emerald-800"
                : "bg-slate-50 border-slate-200 text-slate-700 hover:bg-slate-100"
            }`}
          >
            <ThumbsUp size={12} /> Helpful ({qReactions.helpful})
          </button>
          <button
            onClick={() => handleReaction(activeQuestion.id, "relevant")}
            className={`px-3 py-1.5 rounded-lg border text-xs font-bold transition flex items-center gap-1.5 ${
              qReactions.userVoted === "relevant"
                ? "bg-blue-50 border-blue-300 text-blue-800"
                : "bg-slate-50 border-slate-200 text-slate-700 hover:bg-slate-100"
            }`}
          >
            Target UPSC ({qReactions.relevant})
          </button>
          <button
            onClick={() => handleReaction(activeQuestion.id, "easy")}
            className={`px-3 py-1.5 rounded-lg border text-xs font-bold transition flex items-center gap-1.5 ${
              qReactions.userVoted === "easy"
                ? "bg-amber-50 border-amber-300 text-amber-800"
                : "bg-slate-50 border-slate-200 text-slate-700 hover:bg-slate-100"
            }`}
          >
            Standard ({qReactions.easy})
          </button>
        </div>
      </div>

      {/* ANSWER SUBMISSION EDITOR */}
      <div className="space-y-4 pt-2">
        <div className="flex items-center justify-between">
          <h3 className="text-base font-extrabold text-slate-900 flex items-center gap-2">
            <Send size={16} className="text-red-900" />
            <span>Submit Your Answer / Peer Discussion</span>
          </h3>
          <span className="text-xs font-mono font-semibold text-slate-500">
            Word Count: <strong className="text-slate-800">{wordCount}</strong> / {activeQuestion.words} words
          </span>
        </div>

        {/* Text Formatting Toolbar */}
        <div className="flex flex-wrap items-center gap-1 p-2 bg-slate-50 border border-slate-200 rounded-t-2xl text-slate-600">
          <button
            type="button"
            onClick={() => insertFormatting("b")}
            className="p-1.5 rounded hover:bg-white text-slate-700 font-bold"
            title="Bold"
          >
            <Bold size={14} />
          </button>
          <button
            type="button"
            onClick={() => insertFormatting("i")}
            className="p-1.5 rounded hover:bg-white text-slate-700 italic"
            title="Italic"
          >
            <Italic size={14} />
          </button>
          <button
            type="button"
            onClick={() => insertFormatting("u")}
            className="p-1.5 rounded hover:bg-white text-slate-700 underline"
            title="Underline"
          >
            <Underline size={14} />
          </button>
          <button
            type="button"
            onClick={() => insertFormatting("code")}
            className="p-1.5 rounded hover:bg-white text-slate-700"
            title="Code Block"
          >
            <Code size={14} />
          </button>
          <button
            type="button"
            onClick={() => insertFormatting("quote")}
            className="p-1.5 rounded hover:bg-white text-slate-700"
            title="Quote"
          >
            <Quote size={14} />
          </button>
          <button
            type="button"
            onClick={() => insertFormatting("link")}
            className="p-1.5 rounded hover:bg-white text-slate-700"
            title="Insert Link"
          >
            <LinkIcon size={14} />
          </button>
        </div>

        {/* Textarea */}
        <textarea
          rows={7}
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
          placeholder="Write your answer structure here (Introduction, Body Points, Conclusion)... Or upload your handwritten answer sheet below."
          className="w-full p-4 bg-white border border-slate-200 rounded-b-2xl text-xs sm:text-sm font-serif leading-relaxed text-slate-900 focus:outline-none focus:ring-2 focus:ring-red-900/20 focus:border-red-900 -mt-2"
        />

        {/* Attachment uploader */}
        <div className="flex flex-wrap items-center justify-between gap-3 p-3 bg-slate-50 border border-slate-200 rounded-xl text-xs">
          <label className="cursor-pointer inline-flex items-center gap-1.5 font-bold text-slate-700 hover:text-red-900">
            <input
              type="file"
              accept=".pdf,image/*"
              className="hidden"
              onChange={(e) => setUploadedAttachment(e.target.files[0])}
            />
            <FileText size={15} />
            <span>Upload Handwritten Answer PDF / Image</span>
          </label>

          {uploadedAttachment && (
            <span className="font-mono text-[11px] text-emerald-700 font-bold flex items-center gap-1">
              ✓ {uploadedAttachment.name}
            </span>
          )}
        </div>

        {/* Details Form (Name, Email, Over 18) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-1">
          <div>
            <input
              type="text"
              value={candidateName}
              onChange={(e) => setCandidateName(e.target.value)}
              placeholder="Your Full Name (Aspirant) *"
              className="w-full px-3.5 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs font-medium text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-900/20"
            />
            {formErrors.name && (
              <span className="text-[10px] text-rose-600 block mt-0.5">{formErrors.name}</span>
            )}
          </div>

          <div>
            <input
              type="email"
              value={candidateEmail}
              onChange={(e) => setCandidateEmail(e.target.value)}
              placeholder="Email or Mobile Number *"
              className="w-full px-3.5 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs font-medium text-slate-800 focus:outline-none focus:ring-2 focus:ring-red-900/20"
            />
            {formErrors.email && (
              <span className="text-[10px] text-rose-600 block mt-0.5">{formErrors.email}</span>
            )}
          </div>
        </div>

        <div className="flex items-center justify-between pt-2">
          <label className="flex items-center gap-2 text-xs text-slate-600 cursor-pointer">
            <input
              type="checkbox"
              checked={isOver18}
              onChange={(e) => setIsOver18(e.target.checked)}
              className="rounded text-red-900 focus:ring-red-900 cursor-pointer"
            />
            <span>I confirm I am 18 years or older</span>
          </label>

          <button
            type="button"
            onClick={handlePostAnswer}
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-xl bg-red-900 hover:bg-red-800 text-white font-bold text-xs shadow-md transition-all active:scale-95 cursor-pointer"
          >
            <Send size={14} />
            <span>Post Answer for Evaluation</span>
          </button>
        </div>
      </div>

      {/* DISCUSSIONS STREAM (PEER REVIEWS & MENTOR COMMENTS) */}
      <div className="space-y-4 pt-6 border-t border-slate-200">
        <h4 className="text-sm font-black uppercase tracking-wider text-slate-900 flex items-center gap-2">
          <MessageSquare size={16} className="text-red-900" />
          <span>Discussion Stream ({currentComments.length} Comments)</span>
        </h4>

        {currentComments.length === 0 ? (
          <div className="p-8 text-center text-slate-400 text-xs bg-slate-50 rounded-2xl">
            No answers or comments posted yet for this question. Be the first to submit!
          </div>
        ) : (
          <div className="space-y-4">
            {currentComments.map((comment) => (
              <div
                key={comment.id}
                className={`p-5 rounded-2xl border transition-all ${
                  comment.isMentor
                    ? "bg-gradient-to-r from-red-50/70 to-amber-50/50 border-red-200"
                    : "bg-slate-50/70 border-slate-200"
                }`}
              >
                <div className="flex items-center justify-between gap-3 mb-2">
                  <div className="flex items-center gap-2.5">
                    <div
                      className={`w-7 h-7 rounded-lg flex items-center justify-center font-bold text-xs ${
                        comment.isMentor
                          ? "bg-red-900 text-white"
                          : "bg-slate-200 text-slate-800"
                      }`}
                    >
                      {comment.initial}
                    </div>
                    <div>
                      <span className="font-bold text-xs text-slate-900 block leading-none">
                        {comment.author}
                      </span>
                      <span className="text-[10px] text-slate-400">{comment.time}</span>
                    </div>
                  </div>

                  {comment.isMentor && (
                    <span className="text-[10px] font-extrabold uppercase tracking-wider bg-red-100 text-red-900 px-2 py-0.5 rounded">
                      Official Mentor
                    </span>
                  )}
                </div>

                <p className="text-xs sm:text-sm text-slate-800 leading-relaxed font-serif whitespace-pre-line mt-2">
                  {comment.text}
                </p>

                {comment.attachment && (
                  <div className="mt-2 text-[11px] font-mono text-emerald-800 bg-white border border-slate-200 px-2 py-1 rounded-md inline-flex items-center gap-1.5">
                    <FileText size={12} />
                    <span>Attached: {comment.attachment}</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Bottom Prev / Next Question Navigation */}
      <div className="flex items-center justify-between pt-6 border-t border-slate-200">
        {prevQuestion ? (
          <button
            onClick={() => openQuestionDetail(prevQuestion.id)}
            className="inline-flex items-center gap-1.5 text-xs font-bold text-slate-700 hover:text-red-900 cursor-pointer"
          >
            <ArrowLeft size={14} />
            <span>Previous ({prevQuestion.qNumber})</span>
          </button>
        ) : (
          <div />
        )}

        {nextQuestion && (
          <button
            onClick={() => openQuestionDetail(nextQuestion.id)}
            className="inline-flex items-center gap-1.5 text-xs font-bold text-slate-700 hover:text-red-900 cursor-pointer"
          >
            <span>Next ({nextQuestion.qNumber})</span>
            <ArrowRight size={14} />
          </button>
        )}
      </div>
    </div>
  );
}
